// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:38:56.732Z
// Property: Cimarron Pointe Apts. (ID: 6767906449165594)
// Collections: 24 amenities, 5 floorplans (live), 10 photos, 76 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165594",
  "property_external_id": "v351wng",
  "property_zillow_url": "https://www.zillow.com/b/cimarron-pointe-oklahoma-city-ok-5Xkysh/",
  "property_apartments_url": "https://www.apartments.com/cimarron-pointe-apts-oklahoma-city-ok/v351wng/",
  "property_google_business_url": "https://www.google.com/maps/place/Cimarron+Pointe+Apts/data=!4m2!3m1!1s0x0:0xf7342ad9bb810e47?sa=X&ved=2ahUKEwj1jYeN9bySAxWKD0QIHSkaKBcQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cimarron-pointe-apts.",
  "property_name": "Cimarron Pointe Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/cimarron-pointe/",
  "property_domain": null,
  "property_address": "8301 North Council Road",
  "property_full_address": "8301 North Council Road, Oklahoma City, OK, 73132",
  "property_address_1": "8301 North Council Road",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73132",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Northwest Oklahoma City",
  "property_address_latitude": "35.5561",
  "property_address_longitude": "-97.6571",
  "property_email": "cimarronpointe@caseusa.com",
  "property_phone": "(405) 963-2716",
  "property_call_tracking_phone": "833-595-2557",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Cimarron Pointe Apts. in Oklahoma City, comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans while enjoying amenities like a refreshing pool, a cozy clubhouse, and a dog park. Embrace a lifestyle where modern living and community spirit thrive. Your ideal home awaits! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Cimarron Pointe Apartments, where comfortable living meets modern convenience in the heart of Oklahoma City. Our diverse floor plans feature spacious one, two, and three-bedroom apartments, each designed with your lifestyle in mind. Whether you prefer a cozy nook or a larger space to call home, we have options that cater to your needs.\n\nAt Cimarron Pointe, we pride ourselves on offering a wealth of amenities to enhance your living experience. Relax by our sparkling pool, host friends in our inviting clubhouse, or let your little ones roam free in our playground. For your furry friends, our dog park is the perfect place for playtime. Enjoy the ease of on-site laundry facilities and maintenance, ensuring a hassle-free lifestyle. \n\nEach apartment comes equipped with essential features, including air conditioning, high-speed internet access, and modern kitchens complete with dishwashers, refrigerators, and spacious pantries. Enjoy cozy evenings by your fireplace or unwind on your private balcony or patio. \n\nConveniently located near public transportation, and offering a business center and additional storage space, Cimarron Pointe Apartments is designed to meet all your needs. Experience a community where comfort and convenience collide.\n\nFind your new home today at Cimarron Pointe Apartments! Browse our availability or schedule a tour to visit our welcoming community. We can't wait to welcome you!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-5ce1-7459-afab-b955ada6f9a0.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
    "public_id": "019cfb3c-5ce1-7459-afab-b955ada6f9a0",
    "storage_key": "property/6767906449165594/019cfb3c-5ce1-7459-afab-b955ada6f9a0.webp",
    "width": 2000,
    "height": 1100
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "252",
  "property_year_built": "1985",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.03174603174604",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Contact Leasing Office for details",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://cimarronpointeapartmentsoklahomacity.securecafe.com/onlineleasing/cimarron-pointe-apts/floorplans.aspx",
  "property_resident_portal_url": "https://cimarronpointeapartmentsoklahomacity.securecafe.com/residentservices/cimarron-pointe-apts/userlogin.aspx",
  "property_apply_now_url": "https://cimarronpointeapartmentsoklahomacity.securecafe.com/onlineleasing/cimarron-pointe-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-4a25-762c-8303-20e2688b5299.webp",
  "property_primary_logo_media": {
    "alt_text": "Cimarron Pointe Apartments logo",
    "public_id": "019cfb3c-4a25-762c-8303-20e2688b5299",
    "storage_key": "property/6767906449165594/019cfb3c-4a25-762c-8303-20e2688b5299.webp",
    "width": 340,
    "height": 210
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3d-4e55-71df-b72b-7974d06a76e2.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb3d-4e55-71df-b72b-7974d06a76e2",
    "storage_key": "property/6767906449165594/019cfb3d-4e55-71df-b72b-7974d06a76e2.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3d-6363-71ef-ae56-c122a49e3f47.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cimarron Pointe Apartments logo",
    "public_id": "019cfb3d-6363-71ef-ae56-c122a49e3f47",
    "storage_key": "property/6767906449165594/019cfb3d-6363-71ef-ae56-c122a49e3f47.webp",
    "width": 340,
    "height": 210
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3d-6aa6-70f8-8001-0c6b28f06ad7.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cimarron Pointe Apartments logo",
    "public_id": "019cfb3d-6aa6-70f8-8001-0c6b28f06ad7",
    "storage_key": "property/6767906449165594/019cfb3d-6aa6-70f8-8001-0c6b28f06ad7.webp",
    "width": 340,
    "height": 210
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#702d1a",
  "property_secondary_color": "#b95332",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#49371b",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "550 - 1160",
  "property_sqft_min": "550",
  "property_sqft_max": "1160",
  "property_price_range": "779 - 1199",
  "property_price_min": "779",
  "property_price_max": "1199",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/CimarronPointeOKC/photos/",
  "property_instagram_url": "https://www.instagram.com/cimarronpointe/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJD9DkPQAFsocRRw6Bu9kqNPc",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/cimarron-pointe-apartments-oklahoma-city-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cimarron Pointe Apts.",
  "property_home_romance_title": "Embrace a Love for Your New Apartment Community Today",
  "property_home_amenities_blurb": "At Cimarron Pointe Apts. in vibrant Oklahoma City, you'll find a haven tailored to your lifestyle. Choose from spacious one, two, or three-bedroom layouts. Enjoy refreshing swims in the pool, relaxing evenings by the fireplace, and outdoor adventures in our dog park. Your ideal living experience awaits!",
  "property_home_floorplans_blurb": "Welcome to Cimarron Pointe Apts. in vibrant Oklahoma City, where comfort meets style. Choose from our thoughtfully designed one, two, and three-bedroom floor plans to suit your lifestyle. Embrace modern living and community vibes—browse our available apartments today to find your ideal home sweet home!",
  "property_home_gallery_blurb": "At Cimarron Pointe Apts. in Oklahoma City, luxury meets comfort in our thoughtfully designed one, two, and three-bedroom floor plans. Enjoy vibrant amenities such as a sparkling pool, dog park, and friendly clubhouse. Picture yourself living here, where convenience and community truly thrive! Experience your ideal lifestyle today.",
  "property_home_neighborhood_blurb": "Welcome to Cimarron Pointe Apartments, where comfortable living meets vibrant community life in Oklahoma City. Nestled near Southern Nazarene University and serene parks like Martin Park Nature Center and Will Rogers Gardens, our one, two, and three-bedroom homes offer the perfect blend of convenience and tranquility. Uncover local gems just steps away!",
  "property_home_reviews_blurb": "At Cimarron Pointe Apts. in Oklahoma City, residents celebrate a vibrant lifestyle filled with community spirit. One satisfied tenant notes, “The staff truly cares about making this place feel like home.” Ready to understand the exceptional living experience we offer? See what our residents have to say about life here!",
  "property_neighborhood_blurb": "At Cimarron Pointe Apts. in Oklahoma City, a vibrant lifestyle awaits beyond your doorstep. Immerse yourself in nearby treasures like the Oklahoma Museum of Flying and scenic Lake Overholser Iron Bridge. Dive into community life with local libraries, fitness centers, and Southern Nazarene University, making every day a new adventure.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cimarron Pointe Apartments in Oklahoma City, lifestyle meets convenience. Choose from spacious one, two, or three-bedroom floor plans, all enhanced by a sparkling pool, dog park, and on-site maintenance. Enjoy cozy interiors with air conditioning and fireplaces, perfect for modern living. Elevate your everyday experience here!",
  "property_applynow_blurb": "At Cimarron Pointe Apts. in vibrant Oklahoma City, choose from thoughtfully designed one, two, or three-bedroom floor plans. Enjoy resort-style living with a sparkling pool, dog park, and a welcoming clubhouse, all complemented by on-site management. Your ideal home awaits—lease online today and elevate your lifestyle!",
  "property_contactus_blurb": "At Cimarron Pointe Apts. in Oklahoma City, you'll find thoughtfully designed floor plans, ranging from cozy one-bedroom retreats to spacious three-bedroom family homes. Each layout offers a unique living experience that caters to your lifestyle. Have questions? Contact our leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Cimarron Pointe Apts. in Oklahoma City, we offer thoughtfully designed one, two, and three-bedroom floor plans to suit every lifestyle. Have questions? Our FAQs page is your go-to resource for insights about our vibrant community and its features. Find the answers you need to make Cimarron Pointe your new home!",
  "property_floorplans_blurb": "At Cimarron Pointe Apts. in vibrant Oklahoma City, discover thoughtfully designed floor plans tailored for your lifestyle. Whether you seek a cozy one-bedroom, spacious two-bedroom, or room for the whole family in a three-bedroom, your ideal apartment home awaits. Browse our diverse options today and feel right at home!",
  "property_gallery_blurb": "At Cimarron Pointe Apts. in Oklahoma City, vibrant living comes to life. Choose from thoughtfully designed one, two, or three-bedroom floor plans, and indulge in amazing amenities—from relaxing by the pool to letting your dog roam in our park. Picture yourself enjoying the perfect blend of comfort and convenience!",
  "property_interactivemap_blurb": "Welcome to Cimarron Pointe Apts. in vibrant Oklahoma City! Choose from spacious one, two, or three-bedroom floor plans, each featuring modern amenities like air conditioning, a dishwasher, and your own balcony. Enjoy our sparkling pool, dog park, and inviting clubhouse. Use our interactive community map to find your perfect home!",
  "property_pets_blurb": "At Cimarron Pointe Apts. in Oklahoma City, experience the perfect blend of comfort and community. With pet-friendly living options, your furry friend is just as welcome as you are. Enjoy modern amenities, a stunning pool, and a vibrant neighborhood, all designed to elevate your lifestyle. Come home today!",
  "property_referafriend_blurb": "At Cimarron Pointe Apts. in Oklahoma City, vibrant living awaits with thoughtfully designed one, two, and three-bedroom floor plans. Share the joy of your home by referring a friend today—because great friends make great neighbors! Experience a community where comfort and connection thrive. Join us now!",
  "property_residentaccess_blurb": "Welcome to Cimarron Pointe Apts. in vibrant Oklahoma City! Our diverse floor plans—one, two, and three bedrooms—cater to every lifestyle. Access your resident portal to effortlessly manage rent, schedule maintenance, and unlock the community perks that make living here truly exceptional. Enjoy the ease of modern apartment living!",
  "property_reviews_blurb": "At Cimarron Pointe Apartments in Oklahoma City, residents rave about their vibrant living experience, stating, “The community is friendly and welcoming, making it feel like home.” Uncover the heartfelt stories behind the smiles—see what our residents have to say about living at our community! Your new adventure awaits.",
  "property_created_at": "1753982380663",
  "property_scheduletour_blurb": "At Cimarron Pointe Apts. in Oklahoma City, you’ll find thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Picture yourself in a space where comfort meets elegance. Schedule a tour today and hear firsthand why our residents love calling this community home!",
  "property_thankyou_blurb": "Thank you for reaching out to Cimarron Pointe Apts. in vibrant Oklahoma City! With a variety of thoughtfully designed one, two, and three-bedroom floor plans, your ideal home awaits. Our team will connect with you soon to help you take the next step toward comfortable, stylish living.",
  "property_virtualtours_blurb": "At Cimarron Pointe Apts. in Oklahoma City, you'll find thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Dive into our vibrant community and envision your new home—schedule your virtual tour today to experience all that awaits!",
  "property_copyright": "2025 All Rights Reserved. Cimarron Pointe Apts.",
  "property_seo_title_home": "Cimarron Pointe Apts. |  Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_home": "Welcome to Cimarron Pointe Apts. in OKC! Choose from spacious one, two, or three-bedroom layouts with resort-style amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Cimarron Pointe Apts. in Oklahoma City! Choose from spacious one, two, and three-bedroom floor plans that fit your lifestyle.",
  "property_seo_title_amenities": "Amenities | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Cimarron Pointe Apts. in OKC! Enjoy a sparkling pool, dog park, clubhouse & more. Find your perfect home today!",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_gallery": "Discover life at Cimarron Pointe Apts. in OKC—spacious layouts, a pool, dog park, and clubhouse await your new home!",
  "property_seo_title_virtualtours": "Virtual Tours | Cimarron Pointe Apts. Apartments",
  "property_seo_description_virtualtours": "Discover Cimarron Pointe Apts. in OKC! Take a virtual tour of our stylish one to three-bedroom homes and envision your new lifestyle!",
  "property_seo_title_interactivemap": "Interactive Map | Cimarron Pointe Apts. Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Cimarron Pointe Apts. in Oklahoma City! Enjoy spacious floor plans, top-notch amenities, and an interactive map to guide your search.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_neighborhood": "Experience life at Cimarron Pointe Apts. in Oklahoma City! Uncover local gems and vibrant hotspots just outside your door. Your perfect neighborhood awaits!",
  "property_seo_title_contact": "Contact Us | Cimarron Pointe Apts.",
  "property_seo_description_contact": "Contact Cimarron Pointe Apts. in OKC for personalized help with your one to three-bedroom home questions! Our leasing team is ready to assist!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_faqs": "Find answers to your questions about Cimarron Pointe Apts. in OKC! Learn about our floor plans, amenities, and life at our vibrant community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_reviews": "Experience the charm of Cimarron Pointe Apts. in Oklahoma City! Read resident reviews and see why our vibrant community and amenities make every day special.",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_applynow": "Find your perfect space at Cimarron Pointe Apts. in OKC! Enjoy modern amenities like a pool, dog park, and more. Lease your dream home online today!",
  "property_seo_title_residentaccess": "Resident Access | Cimarron Pointe Apts.",
  "property_seo_description_residentaccess": "Access your resident portal at Cimarron Pointe Apts. in Oklahoma City for easy rent payments, maintenance requests, and exclusive community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Cimarron Pointe Apts.",
  "property_seo_description_referafriend": "Refer a friend to Cimarron Pointe Apts in Oklahoma City and enjoy great neighbors! Share the joy of vibrant living in our welcoming community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cimarron Pointe Apts.",
  "property_seo_description_scheduletour": "Experience the charm of Cimarron Pointe Apts in Oklahoma City. Schedule your tour today and step into a lifestyle filled with comfort and community!",
  "property_seo_title_privacy": "Privacy Policy | Cimarron Pointe Apts.",
  "property_seo_description_privacy": "Cimarron Pointe Apts. in Oklahoma City values your privacy. Learn how we protect your information and maintain a secure living environment. Read our policy!",
  "property_seo_title_accessibility": "Website Accessibility | Cimarron Pointe Apts.",
  "property_seo_description_accessibility": "At Cimarron Pointe Apts. in OKC, we champion accessibility and digital inclusion, ensuring every resident feels at home. Join our inclusive community today!",
  "property_seo_title_sitemap": "Sitemap | Cimarron Pointe Apts.",
  "property_seo_description_sitemap": "Navigate Cimarron Pointe Apts. in Oklahoma City! Our sitemap guides you through luxury living, amenities, and vibrant community events. Your new home awaits!",
  "property_seo_title_thankyou": "Thank You | Cimarron Pointe Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out to Cimarron Pointe Apts in Oklahoma City! Our team is excited to assist you in finding your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865001998",
  "amenities": [
    {
      "id": "ec_68db15489ebe8d500610ed60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127396376",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50e6b600ffff9413a7acd4de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127396380",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_439c261e7025a6e3bddb0f99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127396381",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b55134374e6833116fec91b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127396382",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff0604bd0ba4a2405b999092",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127396383",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd9aa179b7a23018e10973a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127396384",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a22b38a97d23242df8464adc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127396385",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4464d54ce4ce98fe10fab9c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127396386",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08f7e33eb43b78884498e5a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127396387",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be29b00c4d362c537ecb24a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127396388",
      "title": "Night Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15d75d84d6893290c7c70cf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127396389",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14e844170097c96c770c71d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "128017276",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ccc0daacf5164c5b5f8b8f57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127397874",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc9857a550268f1b5cc3eae3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127397875",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2012093aecd2bf224b878c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127397876",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc4ffad8de89ac66d4cdfc49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127397877",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a3796e532941a264bcac09e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127397878",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52dc5c70e15506f4bd5e05a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127397879",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26d1c2eb65b4c0d3fcd01053",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127397880",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65f19466154784a8ed2d5409",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127397881",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05dcef78544961448dfd3b06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127397882",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f3a2af1b71b76660131f4f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127397883",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6b38189b3d736d04633daa9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127397884",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6570197e4ac9a27614fff6bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "yardi",
      "external_id": "127397885",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_3b0e0f23-268e-4082-a1cd-e0bfdfe1af7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-7892-757f-9427-cab017174a64.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019d2708-7892-757f-9427-cab017174a64",
        "storage_key": "property/6767906449165594/019d2708-7892-757f-9427-cab017174a64.webp",
        "width": 2000,
        "height": 1100
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Perfect for a refreshing dip or soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165594/019cfb3c-5ce1-7459-afab-b955ada6f9a0.webp"
    },
    {
      "id": "custom_9ffc7c6f-0fb0-4a28-8794-7cb4d8c53fa7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-7877-75a9-b0a6-e5f007d16a92.webp",
      "image_media": {
        "alt_text": "Cimarron Pointe apartment building exterior with entrance and signage.",
        "public_id": "019d2708-7877-75a9-b0a6-e5f007d16a92",
        "storage_key": "property/6767906449165594/019d2708-7877-75a9-b0a6-e5f007d16a92.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Welcome to Cimarron Pointe, where the exterior of our community building features a prominent sign and an inviting entrance with landscaping.",
      "link": "",
      "alt_text": "Cimarron Pointe apartment building exterior with entrance and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165594/019cfb3c-4bc5-708c-9abf-8c4c204aacda.webp"
    },
    {
      "id": "custom_d0d7f0fe-4f44-4d61-a517-dd8158987a2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-7895-70b8-a799-7ad070ee56cf.webp",
      "image_media": {
        "alt_text": "Playground area with slides and swings in the courtyard of an apartment building.",
        "public_id": "019d2708-7895-70b8-a799-7ad070ee56cf",
        "storage_key": "property/6767906449165594/019d2708-7895-70b8-a799-7ad070ee56cf.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community's playground, perfect for family activities and a great place for kids to play and explore.",
      "link": "",
      "alt_text": "Playground area with slides and swings in the courtyard of an apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165594/019cfb3c-4a21-77b9-9a25-63480e922959.webp"
    },
    {
      "id": "custom_2a3493e7-8ddd-48e6-becc-2c11b3c6144e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-7876-72fd-a457-bb6e71bca910.webp",
      "image_media": {
        "alt_text": "Outdoor dog park with agility equipment and apartment buildings in the background.",
        "public_id": "019d2708-7876-72fd-a457-bb6e71bca910",
        "storage_key": "property/6767906449165594/019d2708-7876-72fd-a457-bb6e71bca910.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility obstacles for your furry friends to play and explore. Situated amidst our community's charming apartment buildings.",
      "link": "",
      "alt_text": "Outdoor dog park with agility equipment and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165594/019cfb3c-4bc5-708c-9abf-8b882b7e7c69.webp"
    },
    {
      "id": "custom_e2f7298c-4c8f-4fa9-99da-6c4b774d6cff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-871f-7501-a489-93442f212ea9.webp",
      "image_media": {
        "alt_text": "Common area lounge with comfortable seating, coffee station, and work desk.",
        "public_id": "019d2708-871f-7501-a489-93442f212ea9",
        "storage_key": "property/6767906449165594/019d2708-871f-7501-a489-93442f212ea9.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting common area lounge, complete with plush seating, a convenient coffee station, and a dedicated workspace.",
      "link": "",
      "alt_text": "Common area lounge with comfortable seating, coffee station, and work desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165594/019cfb3c-4a20-703c-ac33-8541e449f97c.webp"
    },
    {
      "id": "custom_5f426ae4-930d-416e-b645-782b3bac4f14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-87f8-758c-99b4-171183663101.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with brick and siding, walkways, and manicured lawns.",
        "public_id": "019d2708-87f8-758c-99b4-171183663101",
        "storage_key": "property/6767906449165594/019d2708-87f8-758c-99b4-171183663101.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Step into a comfortable living space with these well-maintained apartment buildings, featuring attractive exteriors and lush green spaces.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with brick and siding, walkways, and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165594/019cfb3c-4a20-703c-ac33-8a727148745e.webp"
    },
    {
      "id": "custom_3273ee11-bdcd-446b-86e0-fb29028055eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-8829-7273-a4bd-6bc6b29abb65.webp",
      "image_media": {
        "alt_text": "Community lounge area with a desk, printer, and coffee bar.",
        "public_id": "019d2708-8829-7273-a4bd-6bc6b29abb65",
        "storage_key": "property/6767906449165594/019d2708-8829-7273-a4bd-6bc6b29abb65.webp",
        "width": 698,
        "height": 797
      },
      "title": "Community",
      "description": "Relax and recharge in our community lounge, featuring a comfortable workspace with a printer and a convenient coffee bar.",
      "link": "",
      "alt_text": "Community lounge area with a desk, printer, and coffee bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165594/019cfb3c-5af9-73dc-94f9-e4d7416b3f74.webp"
    },
    {
      "id": "custom_c43f3bd8-1636-445c-992f-3e5171b6d5bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-881e-70ec-b4d0-5bfb22f37a94.webp",
      "image_media": {
        "alt_text": "A fenced dog park with agility equipment and benches.",
        "public_id": "019d2708-881e-70ec-b4d0-5bfb22f37a94",
        "storage_key": "property/6767906449165594/019d2708-881e-70ec-b4d0-5bfb22f37a94.webp",
        "width": 698,
        "height": 797
      },
      "title": "Community",
      "description": "Enjoy our community dog park, complete with agility obstacles and plenty of space for your furry friends to play.",
      "link": "",
      "alt_text": "A fenced dog park with agility equipment and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165594/019cfb3c-5afc-7588-9a5d-4a93702a1e49.webp"
    },
    {
      "id": "custom_ecd26453-9ccf-4393-9d07-b402d69af2ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-9010-7444-9a2e-1772ebbb224d.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and accent chair.",
        "public_id": "019d2708-9010-7444-9a2e-1772ebbb224d",
        "storage_key": "property/6767906449165594/019d2708-9010-7444-9a2e-1772ebbb224d.webp",
        "width": 500,
        "height": 333
      },
      "title": "Apartment",
      "description": "Spacious living room with modern furniture and a view into the kitchen area.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, and accent chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165594/019cfb3c-4b93-7749-b456-adbc0afca245.webp"
    },
    {
      "id": "custom_a49d6de3-342f-4354-86dc-abb9f05521fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-9049-717a-8d43-fb54f318184a.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, teal armchair, coffee table, TV, and ceiling fan.",
        "public_id": "019d2708-9049-717a-8d43-fb54f318184a",
        "storage_key": "property/6767906449165594/019d2708-9049-717a-8d43-fb54f318184a.webp",
        "width": 2000,
        "height": 1100
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living room, featuring comfortable seating, a large TV, and ample natural light from the patio doors.",
      "link": "",
      "alt_text": "Living room with gray sofa, teal armchair, coffee table, TV, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165594/019cfb3c-6037-77d7-91da-516ffd487e90.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9e88315b-cc7d-4b53-926a-7fc08f87c485",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Clark Crew BBQ",
      "poi_type": "Restaurants",
      "poi_address": "3510 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Casual establishment with a patio for pit-smoked beef brisket, ribs, pulled pork and more.",
      "poi_long_description": "Diners say this barbecue restaurant serves up delicious burnt ends, brisket, ribs, and sausage, with sides of mac and cheese, baked beans, and cornbread. They also highlight the friendly and attentive service, and the lively back patio with live music.\n\nSome reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-9e78-7015-a69c-663ab3cd5984.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-9e78-7015-a69c-663ab3cd5984",
        "storage_key": "property/6767906449165594/019d2708-9e78-7015-a69c-663ab3cd5984.webp",
        "width": 599,
        "height": 596
      },
      "poi_business_url": "http://www.clarkcrewbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3587788996052338906&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clark-crew-bbq",
      "poi_latitude": "35.5323986",
      "poi_longitude": "-97.5816496",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-724-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-ed10-7118-85e8-b7d5d52cb067.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-ed10-7118-85e8-b7d5d52cb067",
        "storage_key": "property/6767906449165594/019d2708-ed10-7118-85e8-b7d5d52cb067.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6r6_-4asocR2kjBPhVjyjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_770f0b6b-ad08-4713-b797-aa9145e02e18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Louie's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "9401 Lake Hefner Pkwy, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Casual eatery offering burgers and other American eats at a location overlooking Lake Hefner.",
      "poi_long_description": "People say this bar and grill offers delicious burgers, fish tacos, and wraps, and they highlight the sweet potato fries and cherry cocktail. They also like the beautiful lake views, especially at sunset, the live music, and the outdoor patio.\n\nOther reviews mention the noise level can be distracting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-9e78-7015-a69c-6adf7a3eb2f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-9e78-7015-a69c-6adf7a3eb2f5",
        "storage_key": "property/6767906449165594/019d2708-9e78-7015-a69c-6adf7a3eb2f5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://louiesgrillandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13485773733165357309&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "louies-grill--bar",
      "poi_latitude": "35.5657821",
      "poi_longitude": "-97.5775183",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-751-2298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-ed4e-75aa-87d7-bfc54f6518b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-ed4e-75aa-87d7-bfc54f6518b8",
        "storage_key": "property/6767906449165594/019d2708-ed4e-75aa-87d7-bfc54f6518b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSzs7gwbsocR_ViddsIXJ7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_951f48e3-9d66-4865-87c0-1746bdec522a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Meddys",
      "poi_type": "Restaurants",
      "poi_address": "9404 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious dishes like the Meddys Main Plate, hummus bowl, and garlic chicken, with generous portions and fresh, flavorful ingredients. They highlight the reasonable prices, casual and modern atmosphere, and the availability of outdoor seating and live music. They also like the friendly and attentive staff, and the quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-9f13-7199-91dd-6f01d1f6fdc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-9f13-7199-91dd-6f01d1f6fdc1",
        "storage_key": "property/6767906449165594/019d2708-9f13-7199-91dd-6f01d1f6fdc1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.meddys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10733599644329479405&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meddys",
      "poi_latitude": "35.56632889999999",
      "poi_longitude": "-97.5666625",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-546-1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-ed10-7118-85e8-b7d5d52cb067.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-ed10-7118-85e8-b7d5d52cb067",
        "storage_key": "property/6767906449165594/019d2708-ed10-7118-85e8-b7d5d52cb067.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIS_1pD8bsocR7YyE6QFo9ZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_065a34dd-d726-4060-acd5-efeabd2a0d7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Mariscos El General - Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "4559 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Live music and lively restaurant featuring seafood dishes, along with a full bar of cocktails, beer, and wine.",
      "poi_long_description": "People say this seafood restaurant serves delicious aguachiles, ceviche, and octopus. They highlight the generous portions, fresh ingredients, and flavorful dishes. They also like the attentive and friendly staff, and the lively atmosphere with live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-9fac-752d-842c-a9cdc5c468a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-9fac-752d-842c-a9cdc5c468a2",
        "storage_key": "property/6767906449165594/019d2708-9fac-752d-842c-a9cdc5c468a2.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://mariscoselgeneraloklahomacity.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9041095668201211933&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mariscos-el-general---oklahoma-city",
      "poi_latitude": "35.4947375",
      "poi_longitude": "-97.6033184",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-283-2430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-ed10-7118-85e8-b7d5d52cb067.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-ed10-7118-85e8-b7d5d52cb067",
        "storage_key": "property/6767906449165594/019d2708-ed10-7118-85e8-b7d5d52cb067.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyUIWCmMRsocRHch0w5tseH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_c4c10ebe-5e97-4df2-bbd2-5b01373f3665",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Oklahoma City Incredible Pizza Company",
      "poi_type": "Restaurants",
      "poi_address": "5833 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Buffet dining as well as an arcade, laser tag arena and go-karts for kids' parties and other fun days out.",
      "poi_long_description": "Visitors say this pizza restaurant offers a buffet with a variety of food, including pizza, hot dogs, tacos, chicken, and a salad bar, as well as fun attractions like go-karts and laser tag. They like the friendly and helpful staff, the clean facilities, and the great value for families, with many mentioning it's a popular spot for birthday parties.\n\nSome reviews mention the buffet can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-a5ca-726d-9f43-a3313566ee1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-a5ca-726d-9f43-a3313566ee1d",
        "storage_key": "property/6767906449165594/019d2708-a5ca-726d-9f43-a3313566ee1d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://incrediblepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7640346941500558065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-incredible-pizza-company",
      "poi_latitude": "35.5504818",
      "poi_longitude": "-97.6162357",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-728-8360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-ed10-7118-85e8-b7d5d52cb067.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-ed10-7118-85e8-b7d5d52cb067",
        "storage_key": "property/6767906449165594/019d2708-ed10-7118-85e8-b7d5d52cb067.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30Sq7dMEsocR8QriIBD3B2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_f452f8de-7b6a-4006-be8e-af8de396a63f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Feria Latina Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "4909 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Latino grocery and food store featuring fresh produce and a bakery.",
      "poi_long_description": "People say this supermarket offers fresh produce and delicious bakery items. They also highlight the reasonable prices on marinated meats and the convenient on-site restaurant.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-a514-7112-b7f7-003f1ac91f48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-a514-7112-b7f7-003f1ac91f48",
        "storage_key": "property/6767906449165594/019d2708-a514-7112-b7f7-003f1ac91f48.webp",
        "width": 949,
        "height": 1265
      },
      "poi_business_url": "http://www.laferialatina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7639629429527723566&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "feria-latina-supermarket",
      "poi_latitude": "35.4938889",
      "poi_longitude": "-97.6113889",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-606-4004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-ed4b-76fa-975a-4dbaa0771102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-ed4b-76fa-975a-4dbaa0771102",
        "storage_key": "property/6767906449165594/019d2708-ed4b-76fa-975a-4dbaa0771102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6vpcQIQsocRLr6eWn1qBWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_3694c87f-ffd3-47a6-8fd5-5dae25e0625b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "3535 NW 39th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Fresh meat and produce alongside bulk bins, plus a deli counter.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, bulk items, and bagels. They also highlight the low prices, great deals, and savings, as well as the friendly and helpful staff.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-a749-75de-9086-27cc9ec45ff5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-a749-75de-9086-27cc9ec45ff5",
        "storage_key": "property/6767906449165594/019d2708-a749-75de-9086-27cc9ec45ff5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=888982261208729925&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "35.512444",
      "poi_longitude": "-97.5798107",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-832-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-ed4b-76fa-975a-4dbaa0771102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-ed4b-76fa-975a-4dbaa0771102",
        "storage_key": "property/6767906449165594/019d2708-ed4b-76fa-975a-4dbaa0771102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCahmuZoasocRRUn4EqhMVgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e2bdb313-3c08-4297-a88b-71608f5bfd42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "3801 N May Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Chain home improvement retailer selling items such as appliances, patio furniture, and gardening supplies.",
      "poi_long_description": "People say this home improvement store offers a wide variety of plants, home accessories, and DIY project supplies. They also highlight the helpful and friendly staff, and the well-stocked inventory.\n\nOther reviews mention the store can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-a728-758f-b665-a093bf63cf44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-a728-758f-b665-a093bf63cf44",
        "storage_key": "property/6767906449165594/019d2708-a728-758f-b665-a093bf63cf44.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Oklahoma-City/2540?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2540-_-na-_-0-_-0&y_source=1_MTE4MzI0Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6167616078805409713&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.5099558",
      "poi_longitude": "-97.5672559",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-246-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-ed50-76dd-a2b5-dbb0a564bb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-ed50-76dd-a2b5-dbb0a564bb87",
        "storage_key": "property/6767906449165594/019d2708-ed50-76dd-a2b5-dbb0a564bb87.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJR7Buvn0asocRsR8vcCXGl1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_48ec6832-b086-4027-b189-224e03e32a12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3040 NW 59th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Large hardware chain stocked with a wide selection of tools, lumber and building materials, plus appliances.",
      "poi_long_description": "People say this home improvement store usually has what they need. They also highlight the staff is friendly and helpful.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-ac81-7397-a811-83a084a97162.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ac81-7397-a811-83a084a97162",
        "storage_key": "property/6767906449165594/019d2708-ac81-7397-a811-83a084a97162.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/N-Oklahoma-City/OK/Oklahoma-City/73112/3902?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8923094349114202389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.5313564",
      "poi_longitude": "-97.5691642",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-843-5008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-ed50-76dd-a2b5-dbb0a564bb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-ed50-76dd-a2b5-dbb0a564bb87",
        "storage_key": "property/6767906449165594/019d2708-ed50-76dd-a2b5-dbb0a564bb87.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGSHGIfYasocRFVk_sAgz1Xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_4249053d-14d1-4d91-a1e2-0729ea782ad0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "6100 N May Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Chain selling books and magazines, plus toys and gifts.",
      "poi_long_description": "People say this bookstore offers a huge selection of books, puzzles, music, and toys, and has a Starbucks. They highlight the clean, organized, and quiet atmosphere, and the friendly and helpful staff. They also like the convenient parking and the train table in the kids' section.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-ac8b-700b-8150-d838ddc818a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ac8b-700b-8150-d838ddc818a2",
        "storage_key": "property/6767906449165594/019d2708-ac8b-700b-8150-d838ddc818a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2694",
      "poi_directions_map_url": "https://maps.google.com/?cid=986591179468385464&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barnes--noble",
      "poi_latitude": "35.5331139",
      "poi_longitude": "-97.5647667",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-843-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-ed50-76dd-a2b5-dbb0a564bb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-ed50-76dd-a2b5-dbb0a564bb87",
        "storage_key": "property/6767906449165594/019d2708-ed50-76dd-a2b5-dbb0a564bb87.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvczS4lgasocRuCy_VnMTsQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_a86224cd-38c4-4f2b-b721-4083e76100ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Southern Nazarene University",
      "poi_type": "Education",
      "poi_address": "6729 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-b08f-763f-bd59-f029074d3adb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-b08f-763f-bd59-f029074d3adb",
        "storage_key": "property/6767906449165594/019d2708-b08f-763f-bd59-f029074d3adb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2990625230431240297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-nazarene-university",
      "poi_latitude": "35.5135594",
      "poi_longitude": "-97.6288124",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-789-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f228-7458-a70a-1de191b44621.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f228-7458-a70a-1de191b44621",
        "storage_key": "property/6767906449165594/019d2708-f228-7458-a70a-1de191b44621.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHYsS70IFsocRacAsVM3VgCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b1fe2952-689c-4eb0-869a-409759693630",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Belle Isle Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "5501 N Villa Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Warm, friendly public library with a children’s area, study rooms and computers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-afca-772d-bd6b-94bc6e7c0abf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-afca-772d-bd6b-94bc6e7c0abf",
        "storage_key": "property/6767906449165594/019d2708-afca-772d-bd6b-94bc6e7c0abf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=12135984821329026772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "belle-isle-library---metropolitan-library-system",
      "poi_latitude": "35.52557300000001",
      "poi_longitude": "-97.5569692",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-843-9601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f228-7458-a70a-1de191b44621.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f228-7458-a70a-1de191b44621",
        "storage_key": "property/6767906449165594/019d2708-f228-7458-a70a-1de191b44621.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWXwrG2gasocR1F7ZUuWta6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_9e4fdbb8-7613-44e8-9d2d-b39a5e45857f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Patience S. Latting Northwest Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "5600 NW 122nd St, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Modern, welcoming library featuring kid-friendly activities and patios, plus a large selection of books.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-b273-74d1-8e17-5d592870380d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-b273-74d1-8e17-5d592870380d",
        "storage_key": "property/6767906449165594/019d2708-b273-74d1-8e17-5d592870380d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6566230327670178026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "patience-s-latting-northwest-library---metropolitan-library-system",
      "poi_latitude": "35.5941759",
      "poi_longitude": "-97.6179217",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-606-3580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f228-7458-a70a-1de191b44621.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f228-7458-a70a-1de191b44621",
        "storage_key": "property/6767906449165594/019d2708-f228-7458-a70a-1de191b44621.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkacMZVEDsocR6oAtkrHvH1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_1eb75fb4-e58f-4143-9e91-4022ada4f0c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Bethany Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "6700 NW 35th St, Bethany, OK 73008, USA",
      "poi_short_description": "Public library offering kid-friendly activities, meeting rooms, and other resources.",
      "poi_long_description": "People say this public library offers a diverse selection of books and a variety of activities for all ages. They highlight the cozy atmosphere and the availability of meeting rooms. They also like the helpful and attentive staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-b5ea-769c-9572-26d2737dd19c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-b5ea-769c-9572-26d2737dd19c",
        "storage_key": "property/6767906449165594/019d2708-b5ea-769c-9572-26d2737dd19c.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=15531442417609680617&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-library---metropolitan-library-system",
      "poi_latitude": "35.5062789",
      "poi_longitude": "-97.6316452",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-789-8363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f228-7458-a70a-1de191b44621.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f228-7458-a70a-1de191b44621",
        "storage_key": "property/6767906449165594/019d2708-f228-7458-a70a-1de191b44621.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV4NBRVwFsocR6SYP95bEitc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_ddd1498d-fcbc-4984-92d6-549e653696cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Heartland Baptist Bible College",
      "poi_type": "Education",
      "poi_address": "4700 NW 10th St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-b653-71d6-9a9e-dabb187ebc02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-b653-71d6-9a9e-dabb187ebc02",
        "storage_key": "property/6767906449165594/019d2708-b653-71d6-9a9e-dabb187ebc02.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.heartlandbaptist.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4259418941410825596&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "heartland-baptist-bible-college",
      "poi_latitude": "35.4770584",
      "poi_longitude": "-97.6066436",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-943-9330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f228-7458-a70a-1de191b44621.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f228-7458-a70a-1de191b44621",
        "storage_key": "property/6767906449165594/019d2708-f228-7458-a70a-1de191b44621.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlWGkiSEQsocRfNVcuPV-HDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b2f8e588-10ed-43ed-b105-817f9f6d6e58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "SNU Football Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Bethany, OK 73008, USA",
      "poi_short_description": "Stadium offering a field and a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-b86b-728c-9841-fc71ec55aff9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-b86b-728c-9841-fc71ec55aff9",
        "storage_key": "property/6767906449165594/019d2708-b86b-728c-9841-fc71ec55aff9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://snuathletics.com/facilities/snu-football-stadium/1",
      "poi_directions_map_url": "https://maps.google.com/?cid=14871021148287990153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "snu-football-stadium",
      "poi_latitude": "35.5210386",
      "poi_longitude": "-97.661832",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f27c-703b-98e5-1cc75f0b8812.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f27c-703b-98e5-1cc75f0b8812",
        "storage_key": "property/6767906449165594/019d2708-f27c-703b-98e5-1cc75f0b8812.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFyihiaEFsocRifkGv_F6YM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_3f21e664-fda1-4486-9102-e5471f68a18e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Lake Overholser Iron Bridge",
      "poi_type": "Entertainment",
      "poi_address": "8703-8709 Overholser Dr, Bethany, OK 73008, USA",
      "poi_short_description": "Historic bridge on the former Route 66, still open to traffic, with scenic views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-b89c-748a-b59d-747b6c16f104.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-b89c-748a-b59d-747b6c16f104",
        "storage_key": "property/6767906449165594/019d2708-b89c-748a-b59d-747b6c16f104.webp",
        "width": 720,
        "height": 491
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1592759798430792050&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-overholser-iron-bridge",
      "poi_latitude": "35.5146149",
      "poi_longitude": "-97.6638523",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQwMnJkFsocRcnn9DZmeGhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_6e4af24f-951c-4e65-a141-8cd070cab45e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Oklahoma Museum of Flying",
      "poi_type": "Entertainment",
      "poi_address": "7110 Millionaire Dr, Bethany, OK 73008, USA",
      "poi_short_description": "Volunteer-powered locale for seeing and touching real planes plus learning about their history and mechanics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-bf03-7184-a313-d759625becbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-bf03-7184-a313-d759625becbb",
        "storage_key": "property/6767906449165594/019d2708-bf03-7184-a313-d759625becbb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/oklahomamuseumofflying/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7234880537762503548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-museum-of-flying",
      "poi_latitude": "35.5337967",
      "poi_longitude": "-97.6380221",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f280-713f-a239-eb218c0851de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f280-713f-a239-eb218c0851de",
        "storage_key": "property/6767906449165594/019d2708-f280-713f-a239-eb218c0851de.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5c3VjhkFsocRfJu4XYR1Z2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_8773d77a-d9d2-4d4a-a4e9-e6811cca0853",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Pirate Stadium",
      "poi_type": "Entertainment",
      "poi_address": "5300 NW 50th St, Oklahoma City, OK 73122, USA",
      "poi_short_description": "Venue used for graduation, track meets, and games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-bf22-77ee-a91e-56d3cc65a138.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-bf22-77ee-a91e-56d3cc65a138",
        "storage_key": "property/6767906449165594/019d2708-bf22-77ee-a91e-56d3cc65a138.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://stadiumconnection.com/ok/stadium.php?id=2852",
      "poi_directions_map_url": "https://maps.google.com/?cid=11523176646670315445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pirate-stadium",
      "poi_latitude": "35.5216132",
      "poi_longitude": "-97.6066534",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-789-7101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f27c-703b-98e5-1cc75f0b8812.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f27c-703b-98e5-1cc75f0b8812",
        "storage_key": "property/6767906449165594/019d2708-f27c-703b-98e5-1cc75f0b8812.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR1OWhrUasocRtW_clBuM6p8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_fccc0e2e-d6c8-4eeb-a611-9ad7d6d4e628",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Herrick Building and Auditorium - SNU",
      "poi_type": "Entertainment",
      "poi_address": "6749 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-bf22-77ee-a91e-4c876adcc263.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-bf22-77ee-a91e-4c876adcc263",
        "storage_key": "property/6767906449165594/019d2708-bf22-77ee-a91e-4c876adcc263.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15681811452994641819&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "herrick-building-and-auditorium---snu",
      "poi_latitude": "35.5123354",
      "poi_longitude": "-97.6304674",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4dCV-0IFsocRm99lQm78oNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_c372f996-8a5b-4c1a-912b-b905abf82b8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of group fitness classes, modern equipment, and childcare, and has a friendly and motivating atmosphere.\n\nOther reviews mention membership cancellation can be difficult and there can be hidden fees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-c133-70fd-b793-2a03b1194e55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c133-70fd-b793-2a03b1194e55",
        "storage_key": "property/6767906449165594/019d2708-c133-70fd-b793-2a03b1194e55.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city-ok",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d474d287-5f4d-4601-989f-538785e065bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Neel Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 N MacArthur Blvd, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-c50a-76c8-80a2-fd5428e2ccf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c50a-76c8-80a2-fd5428e2ccf6",
        "storage_key": "property/6767906449165594/019d2708-c50a-76c8-80a2-fd5428e2ccf6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://neel.vet/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4132737864806100553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "neel-veterinary-hospital",
      "poi_latitude": "35.4972708",
      "poi_longitude": "-97.6183664",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-947-8387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYV66BPkPsocRSe6SHTFvWjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_b65eddaf-069e-4117-a9c5-4899ef140721",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4202 Northwest Expy, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Chain gym offering free high-school memberships, plus tanning beds, massage chairs, and TVs.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and workout options, including tanning beds and massage chairs. They also highlight the clean facilities, spacious layout, and convenient location.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-c517-7529-aa0c-0cd280dba538.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c517-7529-aa0c-0cd280dba538",
        "storage_key": "property/6767906449165594/019d2708-c517-7529-aa0c-0cd280dba538.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oklahoma-city-nw-expressway-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17337479712866526724&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.5386202",
      "poi_longitude": "-97.5960525",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-242-4141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWPVatwasocRBGbz4fAZm_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_85b1cbd3-d85f-4b70-9966-64dfc984bafc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Crunch Fitness - OKC Northwest",
      "poi_type": "Health and Wellness",
      "poi_address": "8490 Northwest Expy, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, weight machines, and tanning beds, and provides childcare services.\n\nOther reviews mention the music can be loud and the cancellation policy can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-c5ed-72fe-b60b-27bfb1a21c52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c5ed-72fe-b60b-27bfb1a21c52",
        "storage_key": "property/6767906449165594/019d2708-c5ed-72fe-b60b-27bfb1a21c52.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/okc-northwest",
      "poi_directions_map_url": "https://maps.google.com/?cid=6916258324870179385&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---okc-northwest",
      "poi_latitude": "35.56632099999999",
      "poi_longitude": "-97.6628647",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-267-6282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWtxzOQFsocROaq5dE18-18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5e4faada-d1f4-4120-9953-edf75706c6b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Colaw Fitness of Oklahoma City Gyms",
      "poi_type": "Health and Wellness",
      "poi_address": "3645 NW 39th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Positive gym, with exercise equipment, tanning beds and massage chairs – plus spiritual wellness.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, tanning beds, and massage chairs. They highlight the affordable membership options, clean facilities, and welcoming atmosphere. They also like the friendly, helpful, and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-c5fc-75c8-a1b3-216aa72801e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c5fc-75c8-a1b3-216aa72801e5",
        "storage_key": "property/6767906449165594/019d2708-c5fc-75c8-a1b3-216aa72801e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://colawfitness.com/gyms/oklahoma-city-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8355987367554066829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "colaw-fitness-of-oklahoma-city-gyms",
      "poi_latitude": "35.5128276",
      "poi_longitude": "-97.5823903",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-838-1644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0nvVDcbsocRjSm2Jj1u9nM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0ea6301a-4a4c-4afa-8e38-8509e58ff16d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "TB Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-cd4c-76bc-b941-c8b11f263c9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-cd4c-76bc-b941-c8b11f263c9e",
        "storage_key": "property/6767906449165594/019d2708-cd4c-76bc-b941-c8b11f263c9e.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fitness-club",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ed8a9526-71aa-4ae4-8cf7-b437c0b9ce83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Bethany YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3400 N Mueller Ave, Bethany, OK 73008, USA",
      "poi_short_description": "Chain fitness center offering amenities such as a pool, basketball courts, and water aerobics classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-cd93-754a-b0a4-d3ab680511ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-cd93-754a-b0a4-d3ab680511ef",
        "storage_key": "property/6767906449165594/019d2708-cd93-754a-b0a4-d3ab680511ef.webp",
        "width": 994,
        "height": 533
      },
      "poi_business_url": "https://ymcaokc.org/branches/bethany/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8306823524238509196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-ymca",
      "poi_latitude": "35.5051032",
      "poi_longitude": "-97.6316419",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-789-0231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wBj710FsocRjEQY3vvDR3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_94ca3c36-d62d-4241-bcb4-3af3f27a1ec7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Four Star Fitness - Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "7013 N May Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Spacious gym featuring weights and cardio equipment, plus personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including dumbbells over 120lbs, Hammer Strength, and Atlantis equipment. They highlight the clean facilities and friendly, helpful staff. They also like the serious and respectful workout environment. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-ce00-77ee-be09-a3a73dd725b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ce00-77ee-be09-a3a73dd725b1",
        "storage_key": "property/6767906449165594/019d2708-ce00-77ee-be09-a3a73dd725b1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fourstarfitnessokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050931711802974728&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "four-star-fitness---oklahoma-city",
      "poi_latitude": "35.54217879999999",
      "poi_longitude": "-97.5664473",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-418-4496",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK6JthFYasocRCKJ1Ww0Uoew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_47e4e248-a32b-4bfd-a3e9-23087b39c7a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Rockwell Plaza YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8300 Glade Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Clean gym with a basketball court.",
      "poi_long_description": "People say this gym offers a pool and a variety of fitness equipment.\n\nOther reviews mention the staff can be unhelpful and the rules can be strict.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-cfc7-715f-8bb3-30bd576da16b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-cfc7-715f-8bb3-30bd576da16b",
        "storage_key": "property/6767906449165594/019d2708-cfc7-715f-8bb3-30bd576da16b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcaokc.org/branches/rockwell-plaza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17719347020841965419&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rockwell-plaza-ymca",
      "poi_latitude": "35.5546582",
      "poi_longitude": "-97.6422942",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-621-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJleKdJ_AEsocRa1cp_TvE5_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0f42c910-4886-4d17-8815-a0c51b29a800",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "INTEGRIS Health Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-d2de-73d9-bf33-9a987f17ff44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d2de-73d9-bf33-9a987f17ff44",
        "storage_key": "property/6767906449165594/019d2708-d2de-73d9-bf33-9a987f17ff44.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baptist.integrisok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369483754313068495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-baptist-medical-center",
      "poi_latitude": "35.5290386",
      "poi_longitude": "-97.5764421",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-949-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f644-71ad-b898-b4eb24432c45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f644-71ad-b898-b4eb24432c45",
        "storage_key": "property/6767906449165594/019d2708-f644-71ad-b898-b4eb24432c45.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX5SM_IasocRz68D4IjO548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6da31abc-c9d1-4a42-a4d1-093f4804bfac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-d2de-73d9-bf33-977c9b81f443.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d2de-73d9-bf33-977c9b81f443",
        "storage_key": "property/6767906449165594/019d2708-d2de-73d9-bf33-977c9b81f443.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTI5OTY2MDItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313836111055257082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city",
      "poi_latitude": "35.607198",
      "poi_longitude": "-97.600529",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-755-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f644-71ad-b898-b4eb24432c45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f644-71ad-b898-b4eb24432c45",
        "storage_key": "property/6767906449165594/019d2708-f644-71ad-b898-b4eb24432c45.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-YSHLkcsocR-n2nn5hkQYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_568a8270-3e52-440e-8815-a9b253fac247",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Will Rogers Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3400 NW 36th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Colorful arboretum featuring disc golf, tennis courts, a greenhouse and picnic sites.",
      "poi_long_description": "People say this botanical garden offers beautiful and well-maintained flower beds with a great variety of plants and flowers. They highlight the free entry and the well-labeled trees, plants, and flowers. They also like the beautiful setting for weddings and quinceañeras.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-d55f-75f8-ac0c-395a79a1d81e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d55f-75f8-ac0c-395a79a1d81e",
        "storage_key": "property/6767906449165594/019d2708-d55f-75f8-ac0c-395a79a1d81e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/will-rogers-gardens",
      "poi_directions_map_url": "https://maps.google.com/?cid=7664107588336218919&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "will-rogers-gardens",
      "poi_latitude": "35.5069148",
      "poi_longitude": "-97.5770745",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-297-1394",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f655-771b-b5db-93fb533f8a49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f655-771b-b5db-93fb533f8a49",
        "storage_key": "property/6767906449165594/019d2708-f655-771b-b5db-93fb533f8a49.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1YeiZYMasocRJ_Mn0z5hXGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_986cc139-ae35-42b9-8dce-c23392f4dd42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Martin Park Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Kid-friendly nature preserve with playgrounds and trails, plus deer and turtles.",
      "poi_long_description": "People say this park offers beautiful trails, a playground, and opportunities to see wildlife like deer, turtles, and birds. They highlight the serene and peaceful atmosphere, and the well-maintained grounds. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-d744-71b1-b3c3-b90ff35a3d04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d744-71b1-b3c3-b90ff35a3d04",
        "storage_key": "property/6767906449165594/019d2708-d744-71b1-b3c3-b90ff35a3d04.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/martin-park-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715724291787303274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-park-nature-center",
      "poi_latitude": "35.6090059",
      "poi_longitude": "-97.6090052",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-297-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f655-771b-b5db-93fb533f8a49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f655-771b-b5db-93fb533f8a49",
        "storage_key": "property/6767906449165594/019d2708-f655-771b-b5db-93fb533f8a49.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71CwarQcsocRaqmda8Qv1YY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_544fc491-5c18-4db0-a5b5-2cef0dee3b52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Stars And Stripes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3701 S Lake Hefner Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Relaxed, family-friendly park bordering Lake Hefner offering a skatepark, plus playgrounds.",
      "poi_long_description": "People say this city park offers a large playground, walking trails, and panoramic views of the lake. They highlight the numerous play areas, tables, and BBQ spaces, as well as the decent parking and proximity to the lake. They also like the ability to build sandcastles and watch boats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-db58-72a0-8fbc-246df0ed2d02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-db58-72a0-8fbc-246df0ed2d02",
        "storage_key": "property/6767906449165594/019d2708-db58-72a0-8fbc-246df0ed2d02.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/34/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=16012526237037472583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stars-and-stripes-park",
      "poi_latitude": "35.5500436",
      "poi_longitude": "-97.5822759",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f655-771b-b5db-93fb533f8a49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f655-771b-b5db-93fb533f8a49",
        "storage_key": "property/6767906449165594/019d2708-f655-771b-b5db-93fb533f8a49.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2tmaBwbsocRR6s9S8brN94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ed93e510-3b64-4e66-86b3-790f7182e2f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Bluff Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11301 N Meridian Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "A large green space featuring walking trails, picnic spots and a playground.",
      "poi_long_description": "Visitors say this park offers well-maintained walking trails, paved trails, and bike trails, and they praise the abundance of wildlife, especially deer. They also highlight the peaceful atmosphere, ideal for nature walks, jogging, or simply relaxing in the outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-da67-779b-a682-44bc18222fdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-da67-779b-a682-44bc18222fdc",
        "storage_key": "property/6767906449165594/019d2708-da67-779b-a682-44bc18222fdc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/8/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=1559565554729670411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluff-creek-park",
      "poi_latitude": "35.584442",
      "poi_longitude": "-97.6065873",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-837-7995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f655-771b-b5db-93fb533f8a49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f655-771b-b5db-93fb533f8a49",
        "storage_key": "property/6767906449165594/019d2708-f655-771b-b5db-93fb533f8a49.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3zaRlYbsocRC9eY7ZuwpBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b2e828e4-65eb-480c-81f8-719fb5adc007",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Dolese Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5105 NW 50th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Park with picnic tables, a playground, a paved cycling trail, disc golf course, and facilities for baseball and fishing.",
      "poi_long_description": "People say this park offers a disc golf course, trails, a playground, and a pond for fishing. They highlight the beautiful scenery, the well-maintained trails, and the friendly people. They also like the calming atmosphere and the ample space for various activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-dc9c-73fa-8cf0-88b5bf6656cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-dc9c-73fa-8cf0-88b5bf6656cd",
        "storage_key": "property/6767906449165594/019d2708-dc9c-73fa-8cf0-88b5bf6656cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15736370327146326173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dolese-park",
      "poi_latitude": "35.52624369999999",
      "poi_longitude": "-97.6055628",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f655-771b-b5db-93fb533f8a49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f655-771b-b5db-93fb533f8a49",
        "storage_key": "property/6767906449165594/019d2708-f655-771b-b5db-93fb533f8a49.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcf9-e8kasocRneiNC3DRYto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_79e74c7d-d487-4429-bed4-88308168a3dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Wiley Post Airport-PWA",
      "poi_type": "Transportation & Transit",
      "poi_address": "5915 Philip J Rhoads Ave, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-dd6b-755c-99af-e69e855ebf57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-dd6b-755c-99af-e69e855ebf57",
        "storage_key": "property/6767906449165594/019d2708-dd6b-755c-99af-e69e855ebf57.webp",
        "width": 1280,
        "height": 1013
      },
      "poi_business_url": "http://www.wileypostairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17919166834402155680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wiley-post-airport-pwa",
      "poi_latitude": "35.5307445",
      "poi_longitude": "-97.6430208",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-316-4061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f67b-7507-97b5-dceea0b2142c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f67b-7507-97b5-dceea0b2142c",
        "storage_key": "property/6767906449165594/019d2708-f67b-7507-97b5-dceea0b2142c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0-vGAMFsocRoFyAy0urrfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_d647da46-0495-4f91-9d46-747b21fc926a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Sundance Airport KHSD",
      "poi_type": "Transportation & Transit",
      "poi_address": "13000 N Sara Rd, Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-e0c1-7253-bf51-952ed6387ffd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e0c1-7253-bf51-952ed6387ffd",
        "storage_key": "property/6767906449165594/019d2708-e0c1-7253-bf51-952ed6387ffd.webp",
        "width": 1280,
        "height": 478
      },
      "poi_business_url": "http://sundanceairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335938299321620831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sundance-airport-khsd",
      "poi_latitude": "35.601503",
      "poi_longitude": "-97.7069306",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-373-3886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f67b-7507-97b5-dceea0b2142c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f67b-7507-97b5-dceea0b2142c",
        "storage_key": "property/6767906449165594/019d2708-f67b-7507-97b5-dceea0b2142c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6eH4NUUBsocRX5nnHM40ihI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_85c85386-f21d-49c0-8ad8-f2e445d694b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Jetset FBO",
      "poi_type": "Transportation & Transit",
      "poi_address": "7220 NW 63rd St, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-e1c9-70cd-b727-1390286f80f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e1c9-70cd-b727-1390286f80f2",
        "storage_key": "property/6767906449165594/019d2708-e1c9-70cd-b727-1390286f80f2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.jetsetfbo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=522519284200811341&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jetset-fbo",
      "poi_latitude": "35.5368188",
      "poi_longitude": "-97.6412624",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-888-8684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f67b-7507-97b5-dceea0b2142c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f67b-7507-97b5-dceea0b2142c",
        "storage_key": "property/6767906449165594/019d2708-f67b-7507-97b5-dceea0b2142c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1b0wrcFsocRTasUQ4VcQAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ad0cdd0b-90c3-4e94-927c-8eb4fba46c8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Express Employment International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9701 Boardwalk Blvd, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-e2d9-704a-bdef-931b80a50f91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e2d9-704a-bdef-931b80a50f91",
        "storage_key": "property/6767906449165594/019d2708-e2d9-704a-bdef-931b80a50f91.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.expresspros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=92586903052956857&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "express-employment-international",
      "poi_latitude": "35.56707",
      "poi_longitude": "-97.666693",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-840-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6z8UW8EsocRuTRTO0zvSAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_61b3b7e1-aa45-4e8b-9893-3d2913c148a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-e2fe-721b-a63a-744d92cf864d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e2fe-721b-a63a-744d92cf864d",
        "storage_key": "property/6767906449165594/019d2708-e2fe-721b-a63a-744d92cf864d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6cbfb5d6-d7ad-4d9b-8b55-0f728afd68f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Schlumberger TLM-D&M",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10546 NW 10th St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-e62d-7179-a7b1-1edd9d8841e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e62d-7179-a7b1-1edd9d8841e3",
        "storage_key": "property/6767906449165594/019d2708-e62d-7179-a7b1-1edd9d8841e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16503236905686134745&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "schlumberger-tlm-dm",
      "poi_latitude": "35.4771982",
      "poi_longitude": "-97.7056063",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-709-1731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0NXwLYIsocR2e-JH4dGB-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3d082774-fd35-49a4-a17d-abe0a38134e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Love's Corporate - Building 50",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3601 NW 63rd St, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-e7e0-73d2-8bed-37398550f5f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e7e0-73d2-8bed-37398550f5f0",
        "storage_key": "property/6767906449165594/019d2708-e7e0-73d2-8bed-37398550f5f0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4599439798442847940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---building-50",
      "poi_latitude": "35.5374849",
      "poi_longitude": "-97.5809021",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8bq4uQasocRxO76tyB-1D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dc04de12-a698-4d05-9515-11fa214e0591",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Pacebutler Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5915 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-e8a3-7258-906e-1cad2e87e404.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e8a3-7258-906e-1cad2e87e404",
        "storage_key": "property/6767906449165594/019d2708-e8a3-7258-906e-1cad2e87e404.webp",
        "width": 500,
        "height": 333
      },
      "poi_business_url": "http://www.pacebutler.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8557959088291269970&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pacebutler-corporation",
      "poi_latitude": "35.4936498",
      "poi_longitude": "-97.6204189",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-755-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f2a3-75e9-a61b-fc3876d3bb9b",
        "storage_key": "property/6767906449165594/019d2708-f2a3-75e9-a61b-fc3876d3bb9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEZOm26MesocRUk3t43L6w3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_25158ef1-8ded-4b06-be24-8153e61b3fdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Earl Harris Bethany Elementary",
      "poi_type": "Education",
      "poi_address": "4311 N Asbury Ave, Bethany, OK 73008, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5505930688411158344&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "earl-harris-bethany-elementary",
      "poi_latitude": "35.5163798",
      "poi_longitude": "-97.6311114",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-789-6673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e",
        "storage_key": "property/6767906449165594/019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ60AHL0IFsocRSEerGMr-aEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9d414393-1e42-4cd0-b069-601c4f9255b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Northridge Elementary School",
      "poi_type": "Education",
      "poi_address": "8501 NW 82nd St, Oklahoma City, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://northridge.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17822805147615769359&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northridge-elementary-school",
      "poi_latitude": "35.5572648",
      "poi_longitude": "-97.6664556",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-722-5560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e",
        "storage_key": "property/6767906449165594/019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN8oomFwEsocRDzOkPNpSV_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f8769de8-3e55-4747-ab5a-130f1a123494",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Hefner Middle School",
      "poi_type": "Education",
      "poi_address": "8400 N MacArthur Blvd, Oklahoma City, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-1331-772b-9e27-ca4bdc25f9a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1331-772b-9e27-ca4bdc25f9a8",
        "storage_key": "property/6767906449165594/019d7912-1331-772b-9e27-ca4bdc25f9a8.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://hefner.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3061661222022488476&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hefner-middle-school",
      "poi_latitude": "35.557427",
      "poi_longitude": "-97.6193703",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-721-2411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e",
        "storage_key": "property/6767906449165594/019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsWfEvs8EsocRnCE9-ag0fSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_455afddd-e448-44a0-9a4b-47763475c005",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Bethany Middle School",
      "poi_type": "Education",
      "poi_address": "4312 N Mueller Ave, Bethany, OK 73008, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-135b-70ca-b188-551cf12b5625.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-135b-70ca-b188-551cf12b5625",
        "storage_key": "property/6767906449165594/019d7912-135b-70ca-b188-551cf12b5625.webp",
        "width": 1280,
        "height": 747
      },
      "poi_business_url": "https://www.bethanyschools.com/o/bms",
      "poi_directions_map_url": "https://maps.google.com/?cid=15784092697073299913&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bethany-middle-school",
      "poi_latitude": "35.5163314",
      "poi_longitude": "-97.6317841",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-787-3240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e",
        "storage_key": "property/6767906449165594/019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOfrAG0IFsocRyTHkJq5cDNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c14b685e-32e0-43e3-bb4d-767aa3b1cf8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Bethany High School Baseball Field",
      "poi_type": "Education",
      "poi_address": "6721 NW 42nd Street, Bethany, OK 73008, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-125c-76ae-a02d-126cf22e05f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-125c-76ae-a02d-126cf22e05f7",
        "storage_key": "property/6767906449165594/019d7912-125c-76ae-a02d-126cf22e05f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3410163095491171981&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bethany-high-school-baseball-field",
      "poi_latitude": "35.5198475",
      "poi_longitude": "-97.6605245",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-789-3801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8e9-7729-bd6c-2117d1f2e89f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8e9-7729-bd6c-2117d1f2e89f",
        "storage_key": "property/6767906449165594/019cfb3c-a8e9-7729-bd6c-2117d1f2e89f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN65vA6IFsocRjdblfERVUy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_5fa8637a-e4f3-428f-ac1a-22bf2fbc597b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Putnam City North High School",
      "poi_type": "Education",
      "poi_address": "11800 N Rockwell Ave, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-1760-715c-a011-f8a11e4f766f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1760-715c-a011-f8a11e4f766f",
        "storage_key": "property/6767906449165594/019d7912-1760-715c-a011-f8a11e4f766f.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://pcnorth.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10895318835090211107&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "putnam-city-north-high-school",
      "poi_latitude": "35.5891349",
      "poi_longitude": "-97.6368418",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-722-4220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e",
        "storage_key": "property/6767906449165594/019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-ZkjjmADsocRI8EsMMHyM5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_05a23bad-ec7b-408a-9282-9f4a1f350a9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Casady School",
      "poi_type": "Education",
      "poi_address": "9500 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-1a24-7618-a9bd-619be9650aa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1a24-7618-a9bd-619be9650aa8",
        "storage_key": "property/6767906449165594/019d7912-1a24-7618-a9bd-619be9650aa8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.casady.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9825637108673764104&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "casady-school",
      "poi_latitude": "35.568469",
      "poi_longitude": "-97.546406",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-749-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e",
        "storage_key": "property/6767906449165594/019cfb3c-a8d4-71d8-85ad-4df38f9a8a5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP8HoKJUbsocRCFtlUuSsW4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_4ffa17ba-b1ec-4fbc-a07e-01eb1b679cf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Charleston's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5907 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Relaxed hangout serving classic pub fare, such as burgers, ribs & tenders, plus wine & cocktails.",
      "poi_long_description": "People say this American restaurant serves delicious chicken Parmesan, glazed carrots, and prime rib. They highlight the fair prices, generous portions, and old-school vibe. They also like the friendly, polite, and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-1d5b-760d-a901-21c292b11075.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1d5b-760d-a901-21c292b11075",
        "storage_key": "property/6767906449165594/019d7912-1d5b-760d-a901-21c292b11075.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.charlestons.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6903457512811478067&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "charleston-s-restaurant",
      "poi_latitude": "35.5507506",
      "poi_longitude": "-97.6202127",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-721-0060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8e1-7480-86e8-e42da36075cd",
        "storage_key": "property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Ttb5tAEsocRMzwhJQgCzl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d63641aa-ef56-48b6-94e9-e03062529662",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Fazoli's",
      "poi_type": "Restaurants",
      "poi_address": "6821 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Fast-food chain doling out baked pastas, subs, pizza & other casual Italian fare plus custom combos.",
      "poi_long_description": "People say this restaurant serves delicious pasta, spaghetti with meat sauce, and Italian subs. They highlight the affordable prices, cozy and comfortable atmosphere, and the friendly and attentive staff. They also like the fast service and the complimentary breadsticks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-207c-75cb-a677-4cda39221eec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-207c-75cb-a677-4cda39221eec",
        "storage_key": "property/6767906449165594/019d7912-207c-75cb-a677-4cda39221eec.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://fazolis.com/stores/ok-oklahoma-city-6821-nw-expressway-73132/?utm_source=yext+GMB&utm_medium=local&utm_campaign=website&y_source=1_MzExNzEyMC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12779409311577029379&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fazoli-s",
      "poi_latitude": "35.5573894",
      "poi_longitude": "-97.6355088",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-720-1343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8e1-7480-86e8-e42da36075cd",
        "storage_key": "property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZc7vDekEsocRAzvehw-VWbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cecf21a3-3b46-4357-9f5d-07499a307aad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Cal's Chicago Style Eatery",
      "poi_type": "Restaurants",
      "poi_address": "7005 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Petite restaurant featuring Chicago-style hot dogs, pizzas and sandwiches.",
      "poi_long_description": "People say this restaurant serves delicious Italian beef sandwiches, Chicago dogs, and gyros. They highlight the fresh ingredients, tender beef, and flavorful au jus. They also like the friendly staff and the authentic Chicago-style decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-2094-72fd-973b-a5d47c98d25c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2094-72fd-973b-a5d47c98d25c",
        "storage_key": "property/6767906449165594/019d7912-2094-72fd-973b-a5d47c98d25c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.calschicagoeateryokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13586519042517171839&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cal-s-chicago-style-eatery",
      "poi_latitude": "35.5595564",
      "poi_longitude": "-97.6380766",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-730-6063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8e1-7480-86e8-e42da36075cd",
        "storage_key": "property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLT3AnJsEsocRf_5QrxUDjbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_47e9458b-63fa-45d7-9be8-805a4e18c1ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Del Taco",
      "poi_type": "Restaurants",
      "poi_address": "6161 N May Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Fast-food chain for Mexican standards like tacos, burritos & quesadillas plus breakfast.",
      "poi_long_description": "Fast-food chain for Mexican standards like tacos, burritos & quesadillas plus breakfast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-257a-70e9-816f-43c106240004.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-257a-70e9-816f-43c106240004",
        "storage_key": "property/6767906449165594/019d7912-257a-70e9-816f-43c106240004.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.deltaco.com/us/ok/oklahoma-city/6161-n-may-avenue?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8729440439984451997&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "del-taco",
      "poi_latitude": "35.5340032",
      "poi_longitude": "-97.5662374",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-848-3973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8e1-7480-86e8-e42da36075cd",
        "storage_key": "property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe-tmvX0bsocRnfEzYdQzJXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_24fbd03a-0422-4fe6-a65a-0d358aec7727",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Slim Chickens",
      "poi_type": "Restaurants",
      "poi_address": "5841 Northwest Expy, Warr Acres, OK 73132, USA",
      "poi_short_description": "Counter-serve chain specializing in chicken dishes, plus Southern sides & desserts served in jars.",
      "poi_long_description": "Diners say this chicken restaurant serves up delicious chicken tenders, fried pickles, and fries, with a variety of tasty sauces, including the Mango Habanero and Korean BBQ. They also highlight the friendly and efficient service, and the clean and open atmosphere with outdoor seating.\n\nSome reviews mention the food can be greasy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-2675-714c-83ad-d4ade824a917.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2675-714c-83ad-d4ade824a917",
        "storage_key": "property/6767906449165594/019d7912-2675-714c-83ad-d4ade824a917.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://slimchickens.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3248583550438286210&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "slim-chickens",
      "poi_latitude": "35.549225",
      "poi_longitude": "-97.6168",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-470-7179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8e1-7480-86e8-e42da36075cd",
        "storage_key": "property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbbMlANQEsocRgiMNA4dJFS0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_52fbfc93-1a98-4cd1-807a-1b6d026ddbb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Sunnyside Diner",
      "poi_type": "Restaurants",
      "poi_address": "9148 N MacArthur Blvd, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Sunny, family-owned venue serving comfort food with vegan options, including popular cinnamon rolls.",
      "poi_long_description": "Diners say this diner serves up delicious cinnamon rolls, pancakes, and breakfast burritos, and they praise the friendly and attentive service. They also highlight the diner's reasonable prices and pleasant atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-2de7-7798-9a6a-7b53d1f174ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2de7-7798-9a6a-7b53d1f174ec",
        "storage_key": "property/6767906449165594/019d7912-2de7-7798-9a6a-7b53d1f174ec.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://eatatsunnyside.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8360246992459314393&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sunnyside-diner",
      "poi_latitude": "35.5638042",
      "poi_longitude": "-97.620361",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-722-8262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8e1-7480-86e8-e42da36075cd",
        "storage_key": "property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYhFRsgEsocR2bQQXFiQBXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_757c7e81-77c6-4009-9244-f5a2c21d2cdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "8315 N Rockwell Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-3024-76bb-89d7-ea314634b78c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3024-76bb-89d7-ea314634b78c",
        "storage_key": "property/6767906449165594/019d7912-3024-76bb-89d7-ea314634b78c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/12808",
      "poi_directions_map_url": "https://maps.google.com/?cid=3275952508498585922&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "35.55584",
      "poi_longitude": "-97.63958",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-506-6086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-8396-721d-ba48-41fa234c2327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-8396-721d-ba48-41fa234c2327",
        "storage_key": "property/6767906449165594/019d7912-8396-721d-ba48-41fa234c2327.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJtfrQIO8EsocRQqkbInOFdi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_fd40806c-ca9c-4287-8db6-ffbb7ab3e1a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Sumo II Steakhouse of Japan",
      "poi_type": "Restaurants",
      "poi_address": "7101 Northwest Expy #230, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Sushi, hibachi, and other Japanese fare in a relaxed venue offering sake and wine.",
      "poi_long_description": "People say this Japanese restaurant offers delicious hibachi, sushi, and bento boxes. They also highlight the generous portions, reasonable prices, and entertaining hibachi chefs.\n\nOther reviews mention the decor can be dated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-2dd5-7616-81fc-53e5a93943b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2dd5-7616-81fc-53e5a93943b9",
        "storage_key": "property/6767906449165594/019d7912-2dd5-7616-81fc-53e5a93943b9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://sumoiisteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2898933698893619275&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sumo-ii-steakhouse-of-japan",
      "poi_latitude": "35.5590429",
      "poi_longitude": "-97.6395785",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-721-2420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8e1-7480-86e8-e42da36075cd",
        "storage_key": "property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf1WkG-wEsocRS6D2BdcUOyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_8d0efe59-d057-4b75-841d-929e877dfc73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "7820 N MacArthur Blvd, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "People say this fast food restaurant serves good burgers and biscuits and gravy.\n\nOther reviews mention the food can be cold and the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-3702-70ea-82c5-fd2cfb65c320.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3702-70ea-82c5-fd2cfb65c320",
        "storage_key": "property/6767906449165594/019d7912-3702-70ea-82c5-fd2cfb65c320.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://locations.whataburger.com/ok/oklahoma-city/7820-n-macarthur-blvd.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=5527173222313542339&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "35.5508359",
      "poi_longitude": "-97.6186513",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-728-9665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8e1-7480-86e8-e42da36075cd",
        "storage_key": "property/6767906449165594/019cfb3c-a8e1-7480-86e8-e42da36075cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrY77FNEEsocRw8IM8MJ2tEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_e74a3c74-5f25-4ef8-9fcd-49e309b7cc14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7800 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Department store offering clothing, toys, and other goods, plus a grocery and a pharmacy.",
      "poi_long_description": "People say this department store offers a wide variety of merchandise and is easy to navigate.\n\nOther reviews mention the service can be unhelpful and the prices can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-3a41-7110-ad25-8696187371e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3a41-7110-ad25-8696187371e8",
        "storage_key": "property/6767906449165594/019d7912-3a41-7110-ad25-8696187371e8.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/622-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=72616393302217797&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.5623547",
      "poi_longitude": "-97.6540121",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-773-2625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8d9-76aa-980d-59b302c5b609",
        "storage_key": "property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ3LN2ooEsocRRRSmlzn8AQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_50b70f04-ae72-4ab2-a1fd-2412b30c4a50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Sam's Club Floral",
      "poi_type": "Shopping & Retail",
      "poi_address": "9000 NW Psge, Oklahoma City, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-3dd7-7324-b81f-2a306d8721fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3dd7-7324-b81f-2a306d8721fe",
        "storage_key": "property/6767906449165594/019d7912-3dd7-7324-b81f-2a306d8721fe.webp",
        "width": 400,
        "height": 400
      },
      "poi_business_url": "https://www.samsclub.com/club/4731-oklahoma-city-ok?FLO=aL",
      "poi_directions_map_url": "https://maps.google.com/?cid=13932141924597667872&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club-floral",
      "poi_latitude": "35.559842",
      "poi_longitude": "-97.6502287",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-773-3602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8d9-76aa-980d-59b302c5b609",
        "storage_key": "property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe0zBZ_QEsocRIJj4x0PpWME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "florist"
    },
    {
      "id": "custom_d62b2b62-6b8a-4f95-b383-4e25f20377ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "9001 NW Psge, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "People say this department store offers a wide selection of clothing, accessories, and seasonal items, and they like the Sephora inside. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nOther reviews mention the Amazon returns can close earlier than the rest of the store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-40f4-768e-b730-a460c508921c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-40f4-768e-b730-a460c508921c",
        "storage_key": "property/6767906449165594/019d7912-40f4-768e-b730-a460c508921c.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/oklahomacity-488.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13701744966133765203&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "35.5616271",
      "poi_longitude": "-97.651654",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-621-1779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8d9-76aa-980d-59b302c5b609",
        "storage_key": "property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgzVq5vQEsocRU1RmpXNgJr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_d6b1ee86-9d60-4ea7-ac8c-8e55a06ed8e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Home Services at The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7620 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-46fa-746d-8cb2-c46602f6df43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-46fa-746d-8cb2-c46602f6df43",
        "storage_key": "property/6767906449165594/019d7912-46fa-746d-8cb2-c46602f6df43.webp",
        "width": 1280,
        "height": 685
      },
      "poi_business_url": "https://www.homedepot.com/l/NW-Oklahoma-City/OK/Oklahoma-City/73132/3909/services?emt=HSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10953998982705016396&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "home-services-at-the-home-depot",
      "poi_latitude": "35.5606637",
      "poi_longitude": "-97.6478698",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 844-476-2140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8e9-7729-bd6c-2117d1f2e89f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8e9-7729-bd6c-2117d1f2e89f",
        "storage_key": "property/6767906449165594/019cfb3c-a8e9-7729-bd6c-2117d1f2e89f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_QC8ofMEsocRTG4fuglsBJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_a73dfb31-2c55-44ca-950b-1dd059bdc580",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "8315 N Rockwell Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of products. They also highlight the competitive prices and helpful employees.\n\nOther reviews mention the pickup service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-4691-7128-ba7b-67bd196ea1e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4691-7128-ba7b-67bd196ea1e8",
        "storage_key": "property/6767906449165594/019d7912-4691-7128-ba7b-67bd196ea1e8.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/oklahoma-city-nw/1860",
      "poi_directions_map_url": "https://maps.google.com/?cid=2895961470460129515&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.5554671",
      "poi_longitude": "-97.6397234",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-506-6086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8d9-76aa-980d-59b302c5b609",
        "storage_key": "property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJL67v1OgEsocR63D-KZ2FMCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_bc293501-b0ce-4b0f-9832-984a1fa882a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Ollie's Bargain Outlet",
      "poi_type": "Shopping & Retail",
      "poi_address": "8101 Northwest Expy, Oklahoma City, OK 73162, USA",
      "poi_short_description": "Discount chain carrying a wide range of closeout merchandise, including food, housewares & toys.",
      "poi_long_description": "People say this discount store offers a wide variety of items, including books, arts and crafts, toys, and home goods. They also highlight the great deals, low prices, and fun shopping experience.\n\nOther reviews mention the store can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-4f88-73da-9258-cf7eba1bdc15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4f88-73da-9258-cf7eba1bdc15",
        "storage_key": "property/6767906449165594/019d7912-4f88-73da-9258-cf7eba1bdc15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ollies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8269498946471917568&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ollie-s-bargain-outlet",
      "poi_latitude": "35.567706",
      "poi_longitude": "-97.657186",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-498-3083",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8d9-76aa-980d-59b302c5b609",
        "storage_key": "property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBceu_zQFsocRAPjsZnopw3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_680aa803-9f5f-4fca-abab-6d0c63ed6d68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "6965 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a wide selection of fresh produce, unique European offerings, and a variety of personal items. They also highlight the great prices, friendly staff, and clean store.\n\nOther reviews mention the shelves can be empty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-4f96-7668-a9d5-04d4e83b3abe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4f96-7668-a9d5-04d4e83b3abe",
        "storage_key": "property/6767906449165594/019d7912-4f96-7668-a9d5-04d4e83b3abe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ok/oklahoma-city/6965-nw-expressway/l792",
      "poi_directions_map_url": "https://maps.google.com/?cid=12653618506545306453&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.55744",
      "poi_longitude": "-97.63695",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8da-707b-aef4-e69b37ae4dc1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8da-707b-aef4-e69b37ae4dc1",
        "storage_key": "property/6767906449165594/019cfb3c-a8da-707b-aef4-e69b37ae4dc1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVJVDyA134cRVRvxbf2umq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_9027037b-0b0e-40d4-a0f4-295a491d648a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "8515 N Rockwell Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-50d5-75fc-a7d8-54671ae25451.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-50d5-75fc-a7d8-54671ae25451",
        "storage_key": "property/6767906449165594/019d7912-50d5-75fc-a7d8-54671ae25451.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6702569701896536085&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "35.5566353",
      "poi_longitude": "-97.6423968",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-722-2464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8d9-76aa-980d-59b302c5b609",
        "storage_key": "property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbfS5KukEsocRFcDW06FPBF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_f3f894ec-e6cb-45ac-835d-d700f5fa6acb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "8357 N Rockwell Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "People say this pet supply store offers a wide variety of products. They also highlight the friendly and helpful staff, and the clean store.\n\nOther reviews mention some items can be stocked on high shelves.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-583d-7647-9e34-fad8d20fd283.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-583d-7647-9e34-fad8d20fd283",
        "storage_key": "property/6767906449165594/019d7912-583d-7647-9e34-fad8d20fd283.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/ok/oklahoma-city-store1516.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=16462577978014273428&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "35.555779",
      "poi_longitude": "-97.6415692",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-720-0104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8d9-76aa-980d-59b302c5b609",
        "storage_key": "property/6767906449165594/019cfb3c-a8d9-76aa-980d-59b302c5b609.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdZcR1egEsocRlI-10nLTduQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_888fce23-7e00-4788-897f-6cda90af97e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Scenic View Lake Hefner",
      "poi_type": "Entertainment",
      "poi_address": "9688-9904 W Lakeshore Dr, Oklahoma City, OK 73162, USA",
      "poi_short_description": "Scenic spot that some visitors say is cool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-5cda-77c8-bfeb-279cdc5011de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5cda-77c8-bfeb-279cdc5011de",
        "storage_key": "property/6767906449165594/019d7912-5cda-77c8-bfeb-279cdc5011de.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9096596638922898578&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "scenic-view-lake-hefner",
      "poi_latitude": "35.573417",
      "poi_longitude": "-97.6158049",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8ea-7613-a654-184eee96be15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8ea-7613-a654-184eee96be15",
        "storage_key": "property/6767906449165594/019cfb3c-a8ea-7613-a654-184eee96be15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcaHcT7IEsocRkvwCgHKaPX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f5522b2e-c2a0-4e2d-876b-345fbc0e8e43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Overholser Park",
      "poi_type": "Entertainment",
      "poi_address": "9398-9000 S Overholser Rd, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Built in 1919, this reservoir features a historic dam, boat ramps, a fishing pier & a pavilion.",
      "poi_long_description": "People say this park offers bike riding, fishing, kayaking, and walking trails. They highlight the relaxing and calm vibe, and the scenic views of the dam and lake. They also like the historic structure and the opportunity to walk across the dam.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-60cc-74fd-bf64-4b4ae3bef7fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-60cc-74fd-bf64-4b4ae3bef7fc",
        "storage_key": "property/6767906449165594/019d7912-60cc-74fd-bf64-4b4ae3bef7fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/224/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13345590610054369473&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "overholser-park",
      "poi_latitude": "35.4843833",
      "poi_longitude": "-97.6681182",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8ea-7613-a654-184eee96be15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8ea-7613-a654-184eee96be15",
        "storage_key": "property/6767906449165594/019cfb3c-a8ea-7613-a654-184eee96be15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6SWxWJkFsocRwVAUrvMPNbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2976277b-110c-440b-b5aa-e302d4a143c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "The Sanctuary Escape",
      "poi_type": "Entertainment",
      "poi_address": "7650 W Reno Ave #805, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Kid-friendly escape room experience with creatively themed scenarios designed for groups of players to solve together.",
      "poi_long_description": "People say this amusement center offers fun and interactive escape rooms with challenging puzzles and immersive sets. They highlight the experience is thrilling, engaging, and perfect for team building and family fun. They also like the friendly and helpful staff, and the attention to detail in the room design.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-6fb4-75bf-ba30-54fbd65397b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6fb4-75bf-ba30-54fbd65397b0",
        "storage_key": "property/6767906449165594/019d7912-6fb4-75bf-ba30-54fbd65397b0.webp",
        "width": 1171,
        "height": 1111
      },
      "poi_business_url": "http://thesanctuaryescape.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6815111591893780849&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-sanctuary-escape",
      "poi_latitude": "35.461513",
      "poi_longitude": "-97.6489058",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-726-1022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8e9-7729-bd6c-2117d1f2e89f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8e9-7729-bd6c-2117d1f2e89f",
        "storage_key": "property/6767906449165594/019cfb3c-a8e9-7729-bd6c-2117d1f2e89f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr7rjlgcisocRccl5g-IjlF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_dfd45b14-937d-469c-8d8f-9c277b7d5c63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Stinchcomb Wildlife Refuge",
      "poi_type": "Entertainment",
      "poi_address": "5100 N Stinchcomb Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Forested wildlife area for hiking, bird-watching, fishing & biking as well as kayaking.",
      "poi_long_description": "People say this wildlife refuge offers hiking trails, kayaking, and fishing opportunities. They highlight the beautiful scenery, access to the river, and the abundance of wildlife, including birds and snakes. They also like the opportunity to get off in nature and enjoy a peaceful escape.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-70b7-76c0-b71c-e76819f81f96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-70b7-76c0-b71c-e76819f81f96",
        "storage_key": "property/6767906449165594/019d7912-70b7-76c0-b71c-e76819f81f96.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=16862425980734090786&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stinchcomb-wildlife-refuge",
      "poi_latitude": "35.5227424",
      "poi_longitude": "-97.6633716",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-a8ea-7613-a654-184eee96be15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3c-a8ea-7613-a654-184eee96be15",
        "storage_key": "property/6767906449165594/019cfb3c-a8ea-7613-a654-184eee96be15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85Pzk84FsocRIi75qBZfA-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_e208617a-0cf9-4313-94f4-a3ec8fdf7526",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Icon Cinema OKC",
      "poi_type": "Entertainment",
      "poi_address": "4623 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Cinema chain featuring self-serve popcorn and soft-drink bars, plus reclining seats.",
      "poi_long_description": "People say this movie theater offers comfortable reclining seats and unlimited popcorn and drinks. They also highlight the reasonable prices, friendly staff, and clean auditoriums.\n\nSome reviews mention the bathrooms can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-738d-760c-9094-3cf0f7da9a8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-738d-760c-9094-3cf0f7da9a8c",
        "storage_key": "property/6767906449165594/019d7912-738d-760c-9094-3cf0f7da9a8c.webp",
        "width": 819,
        "height": 1280
      },
      "poi_business_url": "https://www.iconcinemas.com/locations/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=12971712264852755005&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "icon-cinema-okc",
      "poi_latitude": "35.4951791",
      "poi_longitude": "-97.6053815",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-493-9437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019d7912-84ad-74f9-b150-11353e13a527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-84ad-74f9-b150-11353e13a527",
        "storage_key": "property/6767906449165594/019d7912-84ad-74f9-b150-11353e13a527.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJi_FSDAQQsocRPVIg65PHBLQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_52b64ca9-483b-4514-acdd-7157dedbefa0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "Kirkland Early Childhood Center",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "kirkland-early-childhood-center",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a66583c0-f2c2-416a-906b-4ddc9f4255ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "poi_name": "JOANN Fabrics and Crafts",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "joann-fabrics-and-crafts",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_79c0a55a1e0aeb32937e8eb4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ba3efb55b74091019114f241",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_355d07135d95f429b8d4da20",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_5033c6ffdc2ab3f98ebbc77d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_fc98cf0053f225d92f2756a9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_30f0ca22d64475a317d78c3a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_f0ec9d08-bcaa-4b73-bbb6-27fc4eab950f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "rating": "5.0",
      "name": "Rachel",
      "text": "Well, where to start? I love Case and Associates properties. I’m very picky about where I live. I originally lived at a different location that they only managed rather than owned. When that property sold and Case left, it became a nightmare. I was excited to move back into a Case property here at Cimarron Pointe! Brenda and Kelly are amazing, truly. The property is clean, safe and quiet and has all the Case standards. The neighbors are respectful and the pools are clean and well maintained. My daughter and I are so happy to be back in a well kept community. I have had friends who have lived here over the span of the past decade and they also had great experiences at this property. Great management reflects on this property. Love it here.",
      "date": "2025-07-06",
      "title": ""
    },
    {
      "id": "custom_b5db4ea2-7883-469a-ab37-eed88395e3ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "rating": "5.0",
      "name": "Yvette Cook",
      "text": "I’ve lived here almost a year and I have zero complaints! My neighbors are quiet and respectful. The grounds are very well kept! Maintenance issues are resolved quickly. Best of all, the ladies in the office, Brenda and Kelly are absolute angels. By far, the best customer service I’ve ever received. I truly feel blessed!",
      "date": "2025-02-10",
      "title": ""
    },
    {
      "id": "custom_e2c8dda8-bcbd-444a-b9ab-1886a4614230",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "rating": "5.0",
      "name": "Lynette",
      "text": "So Pleased ..Indeed!\nBrenda and Katie both talked with me!\nPrior … To Moving From Out-Of-State!\nSo When I Arrived That Morning!\nIt Was Like We Were Already Acquainted!\n\nKatie and I worked directly together with my tour and application process!\nVery Dilligently … With True intent Of Getting Me Approved!  And … Ready To Move In!!\n\nBrenda and Katie Are To Be Acknowledged!\nFor Their Professional Manner And Access! And For Truly Being There For Me!\n\nAnd … For Making My Arrival And Lease!\nAt Cimarron Pointe Apartments!\nTruly A Success!\nAnd … A Rewarding Experience!\n\nA Special Thank You!\nAlso To The Entire Team!\nWho Worked To Make My Apartment!\nPleasing And Ready For My Move-In Date!",
      "date": "2025-10-01",
      "title": ""
    },
    {
      "id": "custom_cfe17a46-2bdb-4d3a-8789-fd8a4b8e5386",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "rating": "5.0",
      "name": "Emily Dixon",
      "text": "This is a really nice place to live and quiet for the most part. Brenda is absolutely wonderful, she's the one you want as your apt manager. She's very nice and professional, and a joy to be around, and talk to on the phone! You have a warm feeling when you walk in the office, everyone is so nice. This is my 4th time living in this apt complex, and I'm never disappointed! I love this complex and the office ladies,and my apt! I recommend to everyone because this has always been my favorite place to live, and the best place I've ever lived. Well done ladies! Maintenance is prompt.",
      "date": "2025-06-09",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_03b66702-2b1f-4afb-bbb7-e6d3c3e102d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3d-23df-7487-bb86-4ddd67dc562c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of a swimming pool and apartment buildings.",
        "public_id": "019cfb3d-23df-7487-bb86-4ddd67dc562c",
        "storage_key": "property/6767906449165594/019cfb3d-23df-7487-bb86-4ddd67dc562c.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Cimarron Pointe Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f8518467653046ef20a78c2"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-2514-763a-8a4b-f82192163f43",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "cimarron-pointe-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594"
    },
    {
      "lead_collector_id": "019cf79e-2582-72ed-a0ea-25cd04b0ab62",
      "lead_source": "LANDING_PAGE",
      "name": "cimarron-pointe-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "generator",
      "page_item_url": "apartments-with-pool-west-okc",
      "search_query": "apartments with pool in Northwest Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in NW Oklahoma City",
      "h2_subtitle": "Dive into comfort at Cimarron Pointe Apts, one of the top apartments with pool in Northwest Oklahoma City. Enjoy modern amenities and prime location.",
      "page_copy": "Discover Cimarron Pointe Apts. in the heart of Northwest Oklahoma City, where our community blends convenience with modern living. Our sparkling pool offers residents a refreshing retreat, perfect for hot Oklahoma summers. Here, the choice between one, two, or three-bedroom floor plans provides flexibility tailored to your lifestyle.   \n\nLocated in vibrant Oklahoma City, Cimarron Pointe sets a high standard among apartments with pool in Northwest Oklahoma City. Beyond the pool, residents have the bonus of enjoying a private balcony, perfect for relaxing. With amenities like a clubhouse and an on-site dog park, you’ll find numerous ways to unwind and socialize. Schedule a tour today and take the first step towards your dream home in NW OKC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with white appliances, wooden cabinets, and decorative wall art.",
        "public_id": "019cfb3c-8930-7768-af09-60268e540157",
        "storage_key": "property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in NW Oklahoma City",
      "seo_description": "Discover Cimarron Pointe Apts, featuring a shimmering pool among top-tier amenities in Northwest Oklahoma City. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-oklahoma-city-ok",
      "search_query": "dog-friendly apartments Oklahoma City OK",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Oklahoma City, OK",
      "h2_subtitle": "Welcome to Cimarron Pointe Apts, where we pride ourselves on being one of the most accommodating dog-friendly apartments in Oklahoma City, OK.",
      "page_copy": "Cimarron Pointe Apts. in Oklahoma City, OK, invites pet lovers to explore our dog-friendly community. We understand how important it is for pets to feel at home, which is why our dedicated dog park offers the perfect space for your furry friends to play and socialize. Our vibrant community, set in Northwest Oklahoma City, ensures a wonderful living experience for both you and your pets.\n\nAt Cimarron Pointe, modern living meets pet-friendly facilities, making us a leading choice among dog-friendly apartments in Oklahoma City, OK. With spacious one, two, or three-bedroom floor plans, there's plenty of room for everyone. Enjoy additional amenities like a swimming pool and clubhouse, making our community a haven for pet owners and their pets alike. Visit us today to see why Cimarron Pointe is the ideal home for your entire family.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with white appliances, wooden cabinets, and decorative wall art.",
        "public_id": "019cfb3c-8930-7768-af09-60268e540157",
        "storage_key": "property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Oklahoma City, OK",
      "seo_description": "Discover Cimarron Pointe Apts, a leading destination for dog-friendly living in Oklahoma City, OK. Perfect home for you and your furry friend!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-oklahoma-city-73132",
      "search_query": "air conditioned apartments in Oklahoma City 73132",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in OKC 73132",
      "h2_subtitle": "Stay cool at Cimarron Pointe Apts, offering premier air conditioned apartments in Oklahoma City 73132. Enjoy comfort and modern living today.",
      "page_copy": "At Cimarron Pointe Apts, we provide an oasis of comfort in the heart of Oklahoma City’s 73132 zip code. Our air conditioned apartments are designed to offer you relief from the Oklahoma heat, ensuring you enjoy a refreshing environment year-round. Choose from one, two, or three-bedroom floor plans, each crafted for modern living and ultimate convenience.\n\nPositioned in vibrant Northwest Oklahoma City, Cimarron Pointe isn't just about air conditioned comfort. With amenities such as a shimmering pool, clubhouse, and private balconies, our community enhances your daily living experience. Explore the neighborhood and then unwind in the comfort of your air conditioned haven. Schedule a tour today to see why Cimarron Pointe Apts is the peak of comfort in OKC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with white appliances, wooden cabinets, and decorative wall art.",
        "public_id": "019cfb3c-8930-7768-af09-60268e540157",
        "storage_key": "property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in OKC 73132",
      "seo_description": "Find comfort at Cimarron Pointe Apts, offering air conditioned living in Oklahoma City 73132 with modern amenities. Book your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-oklahoma-county",
      "search_query": "apartments with dishwasher in Oklahoma County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Oklahoma County",
      "h2_subtitle": "Experience convenience at Cimarron Pointe Apts, offering modern apartments with dishwasher in Oklahoma County. Discover superior living today.",
      "page_copy": "Welcome to Cimarron Pointe Apts in Oklahoma County, where every apartment comes equipped with a modern dishwasher, making post-meal cleanup a breeze. Our spacious one, two, and three-bedroom floor plans are designed with convenience in mind, accommodating all your lifestyle needs in a vibrant community setting.\n\nCimarron Pointe sits in lovely Northwest Oklahoma City, offering more than just apartments with dishwasher options. Residents enjoy a blend of luxury amenities, including a shimmering pool, a clubhouse, and private balconies. Our community fosters a balanced lifestyle that combines tranquility, convenience, and modern living. Come see why Cimarron Pointe Apts is the perfect choice in Oklahoma County today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with white appliances, wooden cabinets, and decorative wall art.",
        "public_id": "019cfb3c-8930-7768-af09-60268e540157",
        "storage_key": "property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Oklahoma County",
      "seo_description": "Cimarron Pointe Apts offers convenient living with modern dishwashers in every unit plus top-tier amenities in Oklahoma County. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "generator",
      "page_item_url": "playground-amenities-apartments-oklahoma-city",
      "search_query": "playground amenities apartments in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Playground Amenities Apartments in OKC",
      "h2_subtitle": "Discover the joy at Cimarron Pointe Apts, renowned for having a vibrant playground among its amenities in Oklahoma City. Perfect for family-friendly living.",
      "page_copy": "At Cimarron Pointe Apts, located in the heart of Oklahoma City, our playground amenities add an extra layer of enjoyment for families and residents. Our well-maintained playground offers a safe and fun environment for children to play and make friends, making it a cherished feature of our community.\n\nIn addition to the vibrant playground, Cimarron Pointe Apts presents a variety of amenities designed for modern convenience and active living. Choose from spacious one, two, or three-bedroom units, and enjoy additional luxuries such as a swimming pool, a clubhouse, and private balconies. Experience family-friendly living in a thriving Oklahoma City neighborhood with Cimarron Pointe Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with white appliances, wooden cabinets, and decorative wall art.",
        "public_id": "019cfb3c-8930-7768-af09-60268e540157",
        "storage_key": "property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Playground Amenities Apartments in OKC",
      "seo_description": "Enjoy family-friendly living at Cimarron Pointe Apts in OKC with playground amenities, spacious floor plans, and modern conveniences. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-northwest-oklahoma-city",
      "search_query": "one bedroom apartments northwest oklahoma city",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in NW Oklahoma City",
      "h2_subtitle": "Explore fantastic one bedroom apartments at Cimarron Pointe Apts in Northwest Oklahoma City, perfect for modern and comfortable living.",
      "page_copy": "Cimarron Pointe Apts offers exceptional one bedroom apartments in the vibrant area of Northwest Oklahoma City, ideal for those seeking a blend of style and comfort. Each one bedroom unit is thoughtfully designed with spacious layouts and modern finishes, providing a cozy yet stylish living space.\n\nSituated in a desirable neighborhood, our community provides a host of amenities beyond the comfort of your own apartment. Enjoy a refreshing swim in the pool, relax in the clubhouse, or unwind on a private balcony. Our prime location in Northwest Oklahoma City ensures you're always close to dining, shopping, and entertainment options. Discover the perfect one bedroom apartment at Cimarron Pointe Apts today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with white appliances, wooden cabinets, and decorative wall art.",
        "public_id": "019cfb3c-8930-7768-af09-60268e540157",
        "storage_key": "property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in NW OKC",
      "seo_description": "Find your perfect one bedroom apartment at Cimarron Pointe Apts in Northwest Oklahoma City. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-oklahoma-city-ok",
      "search_query": "two bedroom apartments oklahoma city ok",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Oklahoma City, OK",
      "h2_subtitle": "Discover spacious two bedroom apartments at Cimarron Pointe Apts in Oklahoma City, OK, designed for modern and comfortable living.",
      "page_copy": "At Cimarron Pointe Apts, find your perfect home with our inviting two bedroom apartments situated in the bustling heart of Oklahoma City, OK. These thoughtfully designed spaces offer the ideal blend of comfort and style, providing ample room for living, entertaining, and relaxation.\n\nLiving at Cimarron Pointe means enjoying more than just a beautiful apartment. Residents have access to a range of top-notch amenities including a refreshing pool, private balconies, and a community clubhouse. Located in a vibrant Oklahoma City neighborhood, our two bedroom apartments offer convenience and luxury for any lifestyle. Come and see what makes Cimarron Pointe Apts a standout choice in Oklahoma City today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with white appliances, wooden cabinets, and decorative wall art.",
        "public_id": "019cfb3c-8930-7768-af09-60268e540157",
        "storage_key": "property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in OKC, OK",
      "seo_description": "Explore Cimarron Pointe Apts for spacious two bedroom apartments in Oklahoma City, OK, with modern amenities and a prime location. Schedule a visit now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165594",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-73132",
      "search_query": "three bedroom apartments near 73132",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 73132",
      "h2_subtitle": "Explore spacious three bedroom apartments at Cimarron Pointe Apts, conveniently located near the 73132 area in Oklahoma City.",
      "page_copy": "Cimarron Pointe Apts offers spacious three bedroom apartments that are perfect for families or anyone valuing extra space, located conveniently near the 73132 area. Each apartment is meticulously designed with modern finishes, providing a welcoming atmosphere that feels like home from the moment you step in.\n\nBeyond the expansive living spaces, residents enjoy a variety of community amenities that enhance lifestyle and leisure. Take advantage of our shimmering pool, join friends in the clubhouse, or relax on your private balcony. Nestled in a vibrant part of Northwest Oklahoma City, you'll find everything you need is just around the corner. Discover comfort and convenience with our three bedroom apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with white appliances, wooden cabinets, and decorative wall art.",
        "public_id": "019cfb3c-8930-7768-af09-60268e540157",
        "storage_key": "property/6767906449165594/019cfb3c-8930-7768-af09-60268e540157.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 73132",
      "seo_description": "Find spacious three bedroom apartments near the 73132 area at Cimarron Pointe Apts in OKC. Enjoy modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5157"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-V2L0MR5FB1"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151957"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/cimarron-pointe/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5HHPCDTQ"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165594/019d1bd7-87b0-7365-b0f8-9c6a2bec42cc.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "fa62704a-0c36-49c2-a7f0-782186cbe517"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-552-3272"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64b4e086b2361374eaa671a2"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjAxSFdMWU1ObVVzMnIwVWo5bkJiL0E9PSIsInZhbHVlIjoiUWVKamcyNUNQQmo3RWZjdTh0REJMQT09IiwibWFjIjoiYmE1MjQxZjA2ZTgyMzJhZTc5MTJiM2Y1OTlkMTI2YzYwNjA4MTAzOTM3NTA1M2VhYjcwYzBhOTNlM2MyOGVjMiJ9"
    }
  ],
  "custom_qb_id": "5157",
  "custom_ga4_id": "G-V2L0MR5FB1",
  "custom_repli_id": "10041151957",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/cimarron-pointe/register/",
  "custom_google_gtm_id": "GTM-5HHPCDTQ",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165594/019d1bd7-87b0-7365-b0f8-9c6a2bec42cc.pdf",
  "custom_rentgrata_property_id": "fa62704a-0c36-49c2-a7f0-782186cbe517",
  "custom_ppc_tracking_phone_number": "800-552-3272",
  "custom_residentboost_apartment_id": "64b4e086b2361374eaa671a2",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjAxSFdMWU1ObVVzMnIwVWo5bkJiL0E9PSIsInZhbHVlIjoiUWVKamcyNUNQQmo3RWZjdTh0REJMQT09IiwibWFjIjoiYmE1MjQxZjA2ZTgyMzJhZTc5MTJiM2Y1OTlkMTI2YzYwNjA4MTAzOTM3NTA1M2VhYjcwYzBhOTNlM2MyOGVjMiJ9"
};

export const generatedAt = '2026-08-27T21:38:56.732Z';
